export default {
  date: {
    formats: {
      default: '%d.%m.%Y',
      short: '%e %B',
      long: '%-d %B %Y, %A',
      with_day: '%-d %B, %A',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'Pazar',
      'Pazartesi',
      'Salı',
      'Çarşamba',
      'Perşembe',
      'Cuma',
      'Cumartesi',
    ],
    abbr_day_names: ['Pzr', 'Pzt', 'Sal', 'Çrş', 'Prş', 'Cum', 'Cts'],
    month_names: [
      null,
      'Ocak',
      'Şubat',
      'Mart',
      'Nisan',
      'Mayıs',
      'Haziran',
      'Temmuz',
      'Ağustos',
      'Eylül',
      'Ekim',
      'Kasım',
      'Aralık',
    ],
    abbr_month_names: [
      null,
      'Oca',
      'Şub',
      'Mar',
      'Nis',
      'May',
      'Haz',
      'Tem',
      'Ağu',
      'Eyl',
      'Eki',
      'Kas',
      'Ara',
    ],
    order: ['day', 'month', 'year'],
  },
  number: {
    format: {
      separator: ',',
      delimiter: '.',
      precision: 2,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%n %u',
        unit: 'TL',
        separator: ',',
        delimiter: '.',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '.',
        format: '%%n',
      },
    },
    precision: {
      format: {
        delimiter: '.',
      },
    },
    human: {
      format: {
        delimiter: '.',
        precision: 2,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: 'B',
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'Bin',
          million: 'Milyon',
          billion: 'Milyar',
          trillion: 'Trilyon',
          quadrillion: 'Katrilyon',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'yarım dakika',
      less_than_x_seconds: {
        one: '1 saniyeden az',
        other: '%{count} saniyeden az',
        few: '%{count} saniyeden az',
        many: '%{count} saniyeden az',
        zero: '1 saniyeden az',
      },
      x_seconds: {
        one: '1 saniye',
        other: '%{count} saniye',
        few: '%{count} saniye',
        many: '%{count} saniye',
      },
      less_than_x_minutes: {
        one: '1 dakikadan az',
        other: '%{count} dakikadan az',
        few: '%{count} dakikadan az',
        many: '%{count} dakikadan az',
        zero: '1 dakikadan az',
      },
      x_minutes: {
        one: '1 dakika',
        other: '%{count} dakika',
        few: '%{count} dakika',
        many: '%{count} dakika',
      },
      about_x_hours: {
        one: 'yaklaşık 1 saat',
        other: 'yaklaşık %{count} saat',
        few: 'yaklaşık %{count} saat',
        many: 'yaklaşık %{count} saat',
      },
      x_days: {
        one: '1 gün',
        other: '%{count} gün',
        few: '%{count} gün',
        many: '%{count} gün',
      },
      about_x_months: {
        one: 'yaklaşık 1 ay',
        other: 'yaklaşık %{count} ay',
        few: 'yaklaşık %{count} ay',
        many: 'yaklaşık %{count} ay',
      },
      x_months: {
        one: '1 ay',
        other: '%{count} ay',
        few: '%{count} ay',
        many: '%{count} ay',
      },
      about_x_years: {
        one: 'yaklaşık 1 yıl',
        other: 'yaklaşık %{count} yıl',
        few: 'yaklaşık %{count} yıl',
        many: 'yaklaşık %{count} yıl',
      },
      over_x_years: {
        one: '1 yıldan fazla',
        other: '%{count} yıldan fazla',
        few: '%{count} yıldan fazla',
        many: '%{count} yıldan fazla',
      },
      almost_x_years: {
        one: 'neredeyse 1 yıl',
        other: 'neredeyse %{count} yıl',
        few: 'yaklaşık %{count} yıl',
        many: 'yaklaşık %{count} yıl',
      },
      x_years: {
        one: '1 yıl',
        other: '%{count} yıl',
      },
      x_weeks: {
        one: '1 hafta',
        other: '%{count} hafta',
        few: '%{count} hafta',
        many: '%{count} hafta',
      },
      x_hours: {
        one: '1 saat',
        other: '%{count} saat',
      },
    },
    prompts: {
      year: 'yıl',
      month: 'ay',
      day: 'gün',
      hour: 'saat',
      minute: 'dakika',
      second: 'saniye',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Duvar Kağıdı',
    'aria-label': 'Duvar Kağıdı Belirle',
    'aria-author': 'eser sahibi:',
    set_custom_wallpaper: 'Özel duvar kâğıdı ayarla',
    set_custom_wallpaper_description:
      'İnsanlar dosyalarınızı indirdiğinde onlar üzerinde harika bir izlenim bırakmak için bu transfere kendi duvar kâğıdını verin—endişelenmeyin, bu sizin ',
    default_settings: 'varsayılan ayarlarınızı değiştirmez',
    upload: 'Yükle',
    reset_default: 'Varsayılana sıfırla',
    survey_link: 'Ne düşündüğünüzü bize bildirin',
    file_rules:
      'JPEG/PNG %{minWallpaperWidth} x %{minWallpaperHeight}, maks. %{maxUploadSize} MB',
    storage_size_max: 'maksimum',
    pop_over: {
      new_feature: 'Yeni özellik',
      try_now: 'Hemen deneyin',
      not_today: 'Bugün değil',
      hide_forever: 'Sonsuza kadar saklayın',
      hint: 'Hey, bu ayarları değiştirmeden herhangi bir transfere kendi duvar kâğıdını verebilirsiniz—tek yapmanız gereken, bir transfer göndermeden önce özel bir duvar kâğıdı ayarlamak.',
      introductory_upsell:
        'Hey, artık bu transfere kendi duvar kâğıdını verebilirsiniz.',
    },
    curated_description: {
      one: 'Bernardo Henning’in çizdiği, çeşitli renkli desenlerde kap ve vazolardan oluşan soyut illüstrasyon',
      two: 'Bernardo Henning’in çizdiği, çeşitli renkli desenlerde 3 kap ve vazodan oluşan soyut illüstrasyon',
      three:
        'Ana Cuba’nın çektiği, dağların görüldüğü kırsal manzara fotoğrafı',
      four: 'Ana Cuba’nın çektiği, dağların ve suyun görüldüğü kırsal manzara fotoğrafı',
      five: 'Hiroyuki Izutsu’nun çizdiği, mor bir arka plan önündeki mavi çiçekler illüstrasyonu',
      six: 'Hiroyuki Izutsu’nun çizdiği, alaca karanlıktaki tekne ve deniz fenerinin görüldüğü adalar illüstrasyonu',
    },
    custom_description: 'Özel resminiz',
  },
  page: {
    plus: {
      button: {
        text: "Pro'ya yükselt",
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Beş taneye kadar farklı görsel',
        best_2: 'JPEG ya da PNG',
        best_3: "%{size}'a kadar",
        best_4: '%{resolution} piksel veya üstü',
        best_5: 'GIF ya da video kullanılamaz (üzgünüz)',
        best_title: 'Önemli kısımlar:',
        text: 'Beş taneye kadar dönüşümlü video ya da görselle kendinizi veya markanızı öne çıkarıp merkeze koyun.',
        best_five: 'Videolar için %{videoResolution} piksel',
        best_four: 'Görseller için %{resolution} piksel',
        best_one: 'En fazla beş video veya görsel',
        best_six:
          'Resimli duvar kâğıtları her %{rotationInterval} saniyede bir değişir, %{rotationInterval} saniyeden daha uzun olan videolar kısa kesilir',
        best_three: 'Video/görsel başına maks. %{size}',
        best_two: 'JPEG,PNG veya MP4',
        notice:
          "Dikkat dikkat! Video duvar kâğıtları geldi! <a href='/profile'>Şimdi bir videoyu arka planınız yapabilirsiniz</a>.",
      },
      upsell: {
        benefit_one_alt: 'Kendi WeTransfer sayfanıza sahip olun',
        heading_alt: 'Çalışmalarınızı teslim ederken tarzınızı yansıtın',
        benefit_one: 'Kendi WeTransfer alan adınıza sahip olun',
        benefit_three: 'Transfer e-postalarınızı tasarlayın',
        benefit_two:
          'Dosyalarınızı indirenlere kişiselleştirilmiş duvar kâğıtları gösterin',
        button: {
          action: 'Daha fazla bilgi',
        },
        heading: 'WeTransfer Pro ile markanızı öne çıkarın',
      },
      branding: {
        headline:
          '<strong>En iyilerini siz gönderin.</strong> İnsanlar dosyalarınızı her indirdiklerinde harika bir izlenim bırakın.<br /> <strong>Kolaylıkla alın.</strong> Planınız kapsamında herkes size dosya yükleyebilir.',
        protip: {
          text: '<strong>Profesyonel ipucu:</strong> Birinden transfer mi talep ediyorsunuz? Dosyanın açıklamasını onlar için önceden doldurmak üzere özel bir bağlantı paylaşın.',
          link: 'Daha fazla bilgi',
        },
      },
      pagename: 'Profil ayarları',
      'onboarding-step-two':
        "Dosyalarınızı şık sunun, WeTransfer profilinizi kişiselleştirin ve <a href='%{href}'>%{domain}</a> sitesinden yeni görünümünüzün keyfini çıkarın",
      email_backgrounds: 'E-posta arka planları',
      sent_you_files: 'size bazı dosyalar gönderdi',
      email_background_instruction_with_spec:
        "Kendi arka plan görüntünüzü seçerek yüklemeleri şık bir şekilde sunun. \nEn iyi sonuç için %{resolution} piksel boyutunda bir görsel yükleyin (daha geniş görseller kırpılır). Maksimum dosya boyutu %{size}'tır.",
      receiving: 'Profil e-postası',
      choose_wallpapers: 'Duvar kâğıtları',
      'step-one-banner':
        'Öncelikle WeTransfer sayfanız için bir URL seçin. Bunu daha sonra istediğiniz zaman değiştirebilirsiniz.',
      description: {
        pro: 'WeTransfer sayfanız, insanlar dosyalarınızı her indirdiğinde harika bir izlenim bırakmanıza olanak verir. Burası ayrıca WeTransfer Pro planınız kapsamında herkesin size 200 GB transfer gönderebileceği yerdir.',
        premium:
          'WeTransfer sayfanız, insanlar dosyalarınızı her indirdiğinde harika bir izlenim bırakmanıza olanak verir. Burası ayrıca WeTransfer Premium planınız kapsamında dosya boyutu sınırı olmaksızın herkesin size transfer gönderebileceği yerdir.',
      },
      'instructions-1':
        'Adınızı ve URL’nizi dilediğiniz kadar değiştirebilirsiniz.',
      'instructions-2':
        'Yeni bir URL seçtikten sonra sayfanız hemen güncellenecektir.',
      title: 'Sayfanızı düzenleyin',
      profile_url: "Profil URL'si",
    },
    payment: {
      never_actived_retry:
        'Hesabınız henüz aktif değil. <a href="/payment/retry">%{planName}</a> planını kullanmaya başlamak için kaydınızı tamamlayın',
      pagename: 'Plan ve ödeme',
      autorenew_heading: 'Ödeme bilgileri',
      autorenew_notice:
        '%{deal} %{planName} aboneliğiniz %{autorenewal_attempt} tarihinde otomatik olarak yenilenecektir.',
      will_expire_notice:
        "Pro üyeliğiniz <span class='payment__notice'>%{daysBetween} gün içinde sona erecek</span>. Hesabınızı şimdi yenileyin veya otomatik yenilemeyi ayarlayın.",
      never_actived_notice:
        'Hesabınız henüz etkin değil. <a href="/payment/retry">Pro\'yu kullanmaya başlamak için kaydınızı tamamlayın.</a>',
      manual_renewal_expiry_notice:
        'Pro hesabınız %{expiry} tarihinde sona erecek.',
      to_checkout: 'Ödeme sayfasına git',
      updating: 'Güncelleniyor...',
      yes_disable: 'Evet, devam et',
      review_billing_link: 'Ödeme yönteminizi güncellemek istermisiniz?',
      autorenew_failed:
        "%{deal}/%{period} Pro aboneliğiniz, <span class='payment__notice'><strong>%{daysBetween} gün içinde sona erecek</strong>. Hesabınızı yenileyemedik; lütfen hesabınızı <strong>%{expiry}</strong> tarihinden önce manuel olarak yenileyin.</span>",
      confirm_disable_autorenew:
        'Otomatik yenilemeyi durdurmak istediğinizden emin misiniz?',
      disable_autorenewal: 'Otomatik yenilemeyi durdur',
      enable_autorenewal: 'Otomatik yenilemeyi etkinleştir',
      renew_now: 'Şimdi yenile',
      subscription_expired: 'Pro hesabınızın süresi sona erdi',
      cancel_heading: 'Ayrılık zamanı mı?',
      cancel_info:
        'Sizi anlıyoruz, olur böyle şeyler. Aboneliğinizi iptal ettikten sonra, geride bıraktığınız bir şey olması ihtimaline karşı dosyalarınızı 30 gün daha tutacağız (yastığımızın altında değil - endişelenmeyin). Ayrıca aboneliğinizi dilediğiniz zaman tekrar açabilirsiniz.',
      cancel_info_subscription:
        'Sizi anlıyoruz, olur böyle şeyler. Aboneliğinizi iptal ettikten sonra Pro hesabınızı %{subscriptionExpiryDate} tarihine kadar kullanabileceksiniz. Ondan sonra, geride bıraktığınız bir şey olması ihtimaline karşı dosyalarınızı 30 gün daha tutacağız (yastığımızın altında değil - merak etmeyin). Ayrıca aboneliğinizi dilediğiniz zaman tekrar açabilirsiniz.',
      cancel_now: 'Aboneliği iptal et',
      cancelling: 'İptal ediliyor...',
      confirm_cancel_subscription:
        'Aboneliğinizi iptal etmek istediğinize emin misiniz?',
      confirm_reactivate_subscription:
        'Mükemmel seçim! Ödeme yönteminizi yeniden etkinleştirmek için son bir tıklama daha gerekiyor',
      manual_renewal_in_future_notice:
        '%{deal}/%{period} Pro üyeliğiniz %{daysBetween} gün içinde sona erecek. %{manual_renewal_available_at} tarihinden sonra hesabınızı manuel olarak yenileyebilir veya otomatik yenilemeyi hemen etkinleştirebilirsiniz.',
      reactivate_heading: 'Baştan başlayalım.',
      reactivate_content_top_pro:
        '%{planName} aboneliğinizi yeniden etkinleştirebilirsiniz ve aboneliğiniz hiç iptal etmemiş gibi olur. Hesabınızı WeTransfer Premium’a yükseltmeyi de tercih edebilirsiniz:',
      reactivate_content_top_premium:
        '%{planName} aboneliğinizi yeniden etkinleştirebilirsiniz ve aboneliğiniz hiç iptal etmemiş gibi olur.',
      reactivate_content_bottom_pro:
        'Hesabınızı Premium’a yükseltirseniz sizden %{upfront_payment} ücret alınır ve WeTransfer Premium’u hemen kullanmaya başlayabilirsiniz. %{recurring_payment}/%{interval} olarak ücretlendirilen yeni aboneliğiniz %{recurring_date} tarihinde yenilenecektir.',
      reactivate_pro: 'Pro’yu Yeniden Etkinleştir',
      reactivate_premium: 'Premium’u Yeniden Etkinleştir',
      reactivate_upgrade_to_premium: 'Premium’a Yükselt',
      reactivating: 'Yeniden etkinleştiriliyor...',
      subscription_cancelled:
        'Aboneliğiniz iptal edildi ve otomatik olarak %{daysBetween} gün içerisinde sona erecek.',
      subscription_reactivate_expired_notice: 'Pro hesabınız iptal edildi.',
      subscription_reactivate_notice_pro:
        '%{planName} aboneliğiniz iptal edildi ve %{daysBetween} gün sonra sona erecek.',
      subscription_reactivate_notice_premium:
        '%{planName} aboneliğiniz iptal edildi ve %{daysBetween} gün sonra sona erecek.\nFikrinizi mi değiştirdiniz? Endişelenmeyin, her şey kolayca eski hâline döndürülebilir.',
      subscription_reactivate_notice_trial_before:
        '%{planName} aboneliğiniz iptal edildi ve %{daysBetween} gün sonra sona erecek.\nAboneliğiniz sona erene kadar WeTransfer Premium deneme sürenizin keyfini çıkarmaya devam edebilirsiniz.',
      subscription_reactivate_notice_trial_after:
        '%{planName} aboneliğiniz iptal edildi ve %{daysBetween} gün sonra sona erecek.\n%{trialExpiryDate} tarihine kadar WeTransfer Premium deneme sürenizin keyfini çıkarmaya devam edebilirsiniz.',
      update_method_link: 'Ödeme bilgilerini güncelle',
      autorenew_notice_teams:
        '%{number_of_members} üyeli ekibiniz için %{deal} %{planName} aboneliğiniz %{autorenewal_attempt} tarihinde otomatik olarak yenilenecek.',
      cancellation_cta: 'Aboneliği iptal et',
      cancellation_heading:
        '%{planName} avantajlarına artık ihtiyacınız yok mu?',
      cancellation_heading_trial: 'Aboneliği iptal et',
      cancellation_text:
        'Aboneliğinizi iptal ederseniz, Pro özelliklerini %{subscriptionExpiryDate} tarihine kadar kullanabilirsiniz. Bu tarihten sonra WeTransfer Pro hesabınız ücretsiz bir hesaba dönüştürülecek ve mevcut transferlerinizin süresi 28 gün sonra dolacaktır.',
      cancellation_text_item_1: "%{transfer_limit}'a kadar dosya gönderin",
      cancellation_text_item_2: 'Transferleri parola ile koruma',
      cancellation_text_item_3:
        "%{storage_limit}'a varan transferleri yönetin ve depolayın",
      cancellation_text_item_4:
        'Kendinize ait URL ve özel Pro sayfanıza sahip olmak',
      cancellation_text_item_heading:
        'Ücretsiz bir hesap transfer başına sadece %{free_size_limit} göndermenize izin verir. Şunları artık yapamayacaksınız:',
      cancellation_text_new:
        'Aboneliğinizi şimdi iptal ederseniz %{planName} aboneliğinizi %{subscriptionExpiryDate} tarihine kadar kullanabilirsiniz. Bu tarihten sonra hesabınız ücretsiz plana geçirilecektir.<br /><br />Dikkat: Mevcut transferlerinizin kullanım süresi, aboneliğiniz bittikten sonra en geç 28 gün içinde sona erecektir.',
      cancellation_text_teams:
        'Aboneliğinizi şimdi iptal ederseniz siz ve ekibiniz %{planName} aboneliğini %{subscriptionExpiryDate} tarihine kadar kullanabilirsiniz.<br /><br />Bu tarihten sonra siz ve ekip üyeleriniz dosya transferi gönderemeyecek, sunum slaytları hazırlayamayacak ve birlikte panolar yapamayacaksınız. Ücretsiz plana geçirileceksiniz ve yalnızca kendi WeTransfer hesabınıza giriş yapabileceksiniz.<br /><br />Dikkat: Mevcut transferlerinizin kullanım süresi, aboneliğiniz bittikten sonra en geç 28 gün içinde sona erecektir.',
      premium_trial: {
        feature_list_item_1: 'Boyut sınırı olmayan transferler',
      },
      premium_upgrade: {
        cta: "Premium'a Geçin",
        description:
          "Sizden %{upfront_payment} ücret alınacak ve WeTransfer Premium'u hemen kullanmaya başlayabileceksiniz. %{recurring_payment}/%{interval} olarak ücretlendirilen yeni aboneliğiniz %{recurring_date} tarihinde yenilenecek.",
        feature_list_item_1:
          'Transferlerinizi dosya boyutu limiti olmadan gönderin',
        feature_list_item_2: 'Sınırsız depolama alanı',
        feature_list_item_3: 'Sınırsız portal ve inceleme',
        feature_list_item_4: '%{storageLimit} depolama alanı',
        heading: 'Planınızı yükseltmek ister misiniz?',
      },
      unpaid_invoices: {
        heading: 'Ödenmemiş faturalarınız var',
        item: {
          issued_on: 'Fatura tarihi:',
          pay_invoice: 'Faturayı öde',
          pending_invoice: 'Beklemede...',
        },
        subheading:
          'Görünüşe göre önceki ödemelerinizle ilgili bir sorun var. Lütfen ödenmemiş faturaları ödeyin, aksi takdirde Pro aboneliğiniz iptal edilebilir.',
        subheading_2:
          'Bekleyen faturalarınız varsa bir yere ayrılmayın. Birkaç gün içinde tekrar deneyeceğiz ve ödeme başarılı olursa her şey yoluna girecek.',
      },
      upgrade_cta: 'Hesap Yükseltme',
      app_subscription_banner: {
        title: '%{app_name} aracılığıyla abone olmuşsunuz',
        content:
          'Aboneliğinizi görüntülemek veya yönetmek için, telefonunuzdan veya bilgisayarınızdan %{app_name} hesabınıza giriş yapın.',
        go_to: 'Şuraya gidin:',
        learn_more: 'Daha fazla bilgi',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Aboneliği iptal et',
      cancellation_disclaimer:
        '*Dikkat: Mevcut transferlerinizin kullanım süresi, hesabınızın seviyesi düşürüldükten 28 gün sonra sona erecek.',
      'current-plan': 'Mevcut plan',
      'free-forever': 'Daima ücretsiz',
      'free-usp-1': "2 GB'a kadar dosya gönderin",
      'free-usp-2': 'Depolama alanı yok',
      'free-usp-3': 'Transfer dosyası kullanım süresi 7 gün*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        "Aboneliğinizi şimdi iptal ederseniz, WeTransfer Pro'yu <b>%{expiration_date}</b> tarihine kadar kullanmaya devam edebilirsiniz. Ondan sonra, ücretsiz bir WeTransfer hesabına geçirileceksiniz - ki bu da hiç fena değil.",
      pagename: "Artık Pro'nun sunduğu avantajlara ihtiyacınız yok mu?",
      'pro-usp-1': "%{transfer_limit}'a kadar dosya gönderin ve alın",
      'pro-usp-2': '1 TB depolama alanı',
      'pro-usp-3': 'Transferlerin son kullanma sürelerine siz karar verin',
      'pro-usp-4':
        '<p>Size özel <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro sayfanız</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Paste® Pro ve Collect Pro\'nun kilidini açın</a>',
    },
    payment_cancel: {
      info_with_end_date:
        "<p>Aboneliğinizi iptal etmiş bulunuyorsunuz ve <b>%{ends_at}</b> itibarıyla hesabınızın seviyesi ücretsiz WeTransfer hesabına düşürülecek.</p>\n<p>Lütfen bize ayrılma nedeninizi söyleyin, böylece WeTransfer Pro'yu sizin fikirlerinizi dikkate alarak geliştirmeye devam edebiliriz.</p>",
      reason_header: 'Gitmenize üzüldük',
      cancel: 'Geri git',
      info: "Bize ayrılma nedeninizi söyleyin, böylece WeTransfer Pro'yu sizin fikirlerinizi dikkate alarak geliştirmeye devam edebiliriz.",
      pagename: 'Gitmeden önce',
      yes_disable: 'Evet, devam et',
    },
    payment_failed: {
      selected_product: 'Bir %{duration} süreli %{planTier} aboneliği',
      change: 'Güncelle',
      complete_order: 'Siparişinizi tamamlayın',
      description: 'Bilgilerinizi gözden geçirin ve siparişinizi tamamlayın',
      description_error:
        'Bir hata oluştu. Bilgilerinizi gözden geçirin ve ödeme sayfasına gidin',
      description_refused:
        'Ödemenizi işleme koyamadı; lütfen ödeme bilgilerinizi kontrol edin ve yeniden deneyin',
      discount: 'İndirim',
      product_description: 'Bir %{duration} süreli WeTransfer Pro aboneliği',
      title: 'Bitmek üzere!',
      total: 'Toplam',
      vat: 'KDV',
      your_details: 'Bilgileriniz',
      your_order: 'Siparişiniz',
      title_error: 'Hmmm, galiba bir sorun var',
      title_refused: 'Hmmm, galiba bir sorun var',
      payment_status_message:
        'Ödemeniz başarılı oldu, ancak bir şeyler ters gitti ve planınızı otomatik olarak güncelleyemedik. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Destek ekibiyle iletişime geçin</a>',
    },
    payment_methods: {
      billed_now: 'Şimdi faturalandırılan',
      info_content: {
        cancel_bullet:
          "Tasalanmayın, iptal etme seçeneğini Hesap Ayarları > Ödeme'de bulabilirsiniz.",
        initial_payment_bullet:
          'İlk ödemeden sonra %{interval} %{price} ücretlendirileceksiniz (tabii aboneliğinizi iptal etmezseniz. Ama etmezsiniz, değil mi? Değil mi?!)',
        update_payment_bullet:
          'Bir sonraki ödemenizin vadesi gelmeden önce ödeme bilgilerinizi ve/veya fatura bilgilerinizi her zaman güncelleyebilirsiniz.',
        month:
          '- İlk ödemenizden sonra (Pro aboneliğinizi iptal etmediğiniz sürece, gerçi iptal etmezsiniz, öyle değil mi?) sizden her ay %{price} tahsil edilecektir.\n- Merak etmeyin. İptal seçeneğini, Hesap Ayarları > Ödeme bölümünde bulabilirsiniz. \n- Ödeme yönteminizi ve/veya iş bilgilerinizi bir sonraki ödemenizin zamanı gelmeden güncelleyebilirsiniz.',
        year: '- İlk ödemeden sonra (Pro aboneliğinizi iptal etmediğiniz takdirde - ama zaten etmezsiniz, değil mi?), sizden yılda bir kez %{price} tahsil edilecektir. \n- Merak etmeyin, iptal seçeneğini Hesap Ayarları > Ödeme menüsünde bulabilirsiniz.\n- Ödeme yönteminizi ve/veya iş bilgilerinizi bir sonraki ödemenizin zamanı gelmeden güncelleyebilirsiniz.',
      },
      payment_cta: 'Ödemeyi tamamla',
      payment_term: {
        monthly: 'ayda bir',
        yearly: 'yılda bir',
      },
      payment_title: 'Ödeme',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Aylık',
        year: 'Yıllık',
      },
      subtotal: 'Ara toplam',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Ödeme yönteminiz',
      bancontact: 'Bancontact',
      card: 'Kredi kartı',
      card_cvc: 'CVC',
      card_expiration: 'AA / YY',
      card_name: 'Kart üzerindeki isim',
      card_number: 'Kart numarası',
      complete_payment: 'Ödemenizi tamamlayın',
      creditcard: 'Kredi kartı',
      discount: 'İndirim',
      do_not_refresh: 'Lütfen bu sayfayı yenilemeyin ya da kapatmayın',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL, ödeme yapmak için müşterilerin kendi bankalarını kullanabildikleri Hollandalı bir çevrim içi ödeme yöntemidir.',
      info: 'Ödeme yöntemini güncelle',
      payment_in_progress: 'Ödemeniz işlemden geçiriliyor...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/ay',
        year: '/yıl',
      },
      select_bank: 'Bankanızı seçin',
      select_country: 'Ülke seçin',
      sofort: 'SOFORT',
      tax: 'KDV',
      title: 'Ödeme yönteminizi seçin',
      total: 'Toplam',
    },
    projects: {
      actions: {
        go_back: 'Tüm projeler',
        discard: 'Değişikliklerden vazgeç',
        edit: 'Düzenle',
        remove_transfer:
          'Bu transfer silinsin mi? Dosyalar bu projeden ve gönderilen transferlerden kaldırılacaktır.',
        save: 'Kaydet',
        share: 'Paylaş',
      },
      transfer_actions: {
        download: 'İndir',
      },
      added_at: '%{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Bağlantıyı kopyala',
        link_copied: 'Bağlantı panoya kopyalandı',
        content_label: 'Bu projenin bağlantısını kopyala',
        list_item_1: 'Yalnızca indirme ve görüntüleme erişimi',
        list_item_2: 'Bağlantı sonsuza kadar aynı kalır',
        title: 'Projeyi paylaş',
      },
      content: {
        empty_state:
          'Projeniz şu anda boş. Proje zaman çizelgenizi başlatmak için işe birkaç dosya ekleyerek başlayın.',
      },
      logo_title: 'wetransfer.com’a geri dön',
      logo_tooltip_caption: 'WeTransfer’a geri dön',
      timestamp: '%{timeAgo} önce',
      chat: {
        owner_button_label: 'Hey… Bizimle konuşun',
        owner_offline_greeting:
          'Şu anda çevrim dışıyız, ancak hangi konuda sorun yaşadığınızı bize söylerseniz bir iş günü içinde size dönüş yapabiliriz.',
        owner_online_greeting:
          'Hangi konuda sorun yaşadığınızı bize söyleyin, mümkün olan en kısa süre içinde size dönüş yapalım',
        receiver_button_label:
          'Sorularınız mı var? Size yardımcı olmak için buradayız',
        receiver_offline_greeting:
          'Hangi konuda sorun yaşadığınızı bize söyleyin, mümkün olan en kısa süre içinde size dönüş yapalım.',
        receiver_online_greeting:
          'Hangi konuda sorun yaşadığınızı bize söyleyin, mümkün olan en kısa süre içinde size dönüş yapalım.',
      },
      created_by: '%{user} tarafından oluşturuldu',
      created_by_fallback: 'Oluşturuldu',
      deliverable_clipboard_modal: {
        content_label: 'Bu çıktının bağlantısını kopyala',
        info: 'İnsanlar projenizi de görebilecektir',
        title: 'Çıktıyı paylaş',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Aradığınız Proje bu değil…',
        limit:
          'Sonsuz bir potansiyeliniz var, ancak karakter limitine ulaştınız',
        required:
          'Ne yapmanız gerektiğini biliyorsunuz. Bunu doldurmadan geçemezsiniz',
      },
      event: {
        project_created_byline:
          'Ne üzerinde çalıştığınızı göstermek için birkaç dosya ekleyin.',
        project_created_title: 'Projenin başlangıcı',
      },
      file_count: {
        one: '%{count} dosya',
        other: '%{count} dosya',
      },
      just_now: 'az önce',
      labels: {
        description: 'Açıklama',
        name: 'Ad',
        new_name: 'Projenize bir ad verin',
      },
      logo: {
        cta: 'Logo ekle',
        errors: {
          dimensions:
            'Logonuz 220 x 220 pikselden küçük. Daha büyük bir görsel deneyin',
          general:
            'Hmm, yanlış giden bir şeyler oldu. Lütfen bir kez daha deneyin',
          size: 'Logonuz 5 MB’den büyük. Daha küçük bir dosya deneyin',
          type: 'Logonuz JPEG, GIF veya PNG değil. Farklı bir görsel deneyin',
        },
        instructions:
          'Logonuz en fazla 5 MB olabilir. JPEG’ler ve GIF’ler uygundur, ancak en iyi sonucu şeffaf arka plana sahip PNG’lerle alırsınız',
        'instructions-title': 'Markanızı öne çıkarın',
      },
      name_modal: {
        content_label: 'Projenize ad verin veya adını değiştirin',
        input_placeholder_0: 'Kesin Cannes Aslanı Geliyor',
        input_placeholder_1: 'Soğuk algınlığına çare',
        input_placeholder_2: 'Kusursuz suç',
        input_placeholder_3: 'Başlıklar Değil, Şarkılar Yazıyorum',
        input_placeholder_4: 'Ödüllü Fikir',
        input_placeholder_5: 'Yepyeni Marka Kampanyası',
        input_placeholder_6: 'Dünya hâkimiyeti',
        save: 'Kaydet',
        text: 'Ne üzerinde çalıştığınızı anlatın.',
        title: 'Projenize bir ad verin',
      },
      new_project_label: 'Yeni projeye başla',
      noticebar: {
        'button-cancel': 'İptal et',
        'button-clear-all-files': 'Hepsini temizle',
        'button-close': 'Kapat',
        'button-delete': 'Sil',
        'button-no': 'Hayır',
        'button-share': 'Paylaş',
        'button-yes': 'Evet',
        'confirm-cancel': 'Bu transfer iptal edilsin mi?',
        'confirm-clear-files-deliverable':
          '<strong><u>%{deliverableName}</u></strong> içindeki tüm dosyalar temizlensin mi?',
        'confirm-complete':
          'Yükleme tamamlandı! Daha fazla dosya eklediğinizi herkese bildirin.',
        'confirm-delete-deliverable':
          '<strong><u>%{deliverableName}</u></strong> ve ona yüklediğiniz dosyalar silinsin mi?',
        'confirm-first-complete':
          'Yükleme tamamlandı! Dosyalarınızın indirilebilmesi için bu projeyi paylaşın.',
        deliverable_not_found_error: 'Hmm, çıktı silinmiş gibi görünüyor',
        general_error:
          'Hay aksi, yanlış giden bir şeyler oldu. Lütfen tekrar deneyin.',
      },
      'onboarding-promise': {
        description:
          'Bir proje için teslim edeceğiniz tüm işleri ana hatlarıyla belirtin ve paylaşma sürecini kolaylaştırın. Bir çıktı listesi hazırlayın, ilerledikçe dosya ekleyin. Artık farklı indirme bağlantıları yok.',
        title: 'Doğru yolda ilerlemek için işe doğru yolda başlayın',
      },
      onboarding: {
        banner:
          'Dikkat! Projeler hâlâ hazırlanırken (ve geliştirilirken) bu özelliğe erişimi olan seçilmiş birkaç kişiden birisiniz. Geri bildirim için size ulaşabiliriz.',
      },
      pagename: 'Projeler',
      placeholders: {
        description: 'Projenize kısa bir açıklama ekleyin',
        loading: 'Yükleniyor...',
      },
      project: {
        notification: {
          name_saved:
            'Ad kaydedildi! Projeniz çok başarılı olacak gibi görünüyor.',
        },
      },
      share_button_label: 'Paylaş',
      unnamed_project_title: 'Adsız Proje',
      watch_video: 'Videoyu izle',
    },
    transfer: {
      display_name_fallback: 'Başlıksız transfer',
      does_not_expire: '<u>son geçerlilik tarihi</u> yok',
      expires_in: '<span>%{time}</span> sonra geçerliliği sona erecek',
      downloaded_at: 'İndirme tarihi: %{date}, saati: %{time}',
      not_downloaded: 'Henüz indirilmedi',
      email_bounced: 'Bunu gönderdiğiniz e-posta adresi geçersiz',
      count_files: {
        one: '%{count} dosya',
        other: '%{count} dosya',
      },
      sent_datetime: 'Gönderme tarihi: %{date}, saati: %{time}',
      never_expires: 'Son geçerlilik tarihi yok',
      and_more: '%{count} tane daha',
      read_more: 'daha fazla',
      copy_link: 'bağlantıyı kopyala',
      message: 'Mesaj',
      total_downloads: 'Toplam indirme',
      sent_to_recipients: {
        one: '%{count} kişiye gönderildi',
        other: '%{count} kişiye gönderildi',
      },
      no_transfers: 'Gönderdiğiniz tüm aktarımlar burada görünecektir',
      add_first_description:
        'İndirme durumunu kontrol edin veya düzenleyin, iletin ya da silin',
      mobile: {
        download: 'Tüm dosyaları indir',
        remove: 'Aktarımı sil',
      },
      delete_datetime: 'Dosyalar %{date} saat %{time} itibarıyla silindi',
      detail: {
        plus_download_stats:
          'Transferlerinizin kaç kez indirildiğini takip etmek için Pro hesabı edinin.',
        plus_password_expiration:
          'Transferlerinize parola ve bitiş tarihi eklemek için Pro hesabı edinin.',
        plus_transfer_actions:
          'Transferlerinizi yönetmek ve istediğinizde silmek için Pro hesabı edinin.',
        title: 'Transfer bilgileriniz',
      },
      download_status_email: '%{count} / %{total} kişi',
      download_status_email_text: {
        zero: 'Henüz indirilmedi',
        one: '%{count} / %{total} kişi',
        other: '%{count} / %{total} kişi',
      },
      download_status_link: {
        one: 'bir kez',
        other: '%{count} kez',
      },
      download_status_link_text: {
        zero: 'Henüz indirilmedi',
        one: '1 kez',
        other: '%{count} kez',
      },
      sent_moment: '%{moment} gönderildi',
      total_downloads_tooltip:
        'Beklediğinizden farklı mı? Yakın zaman önce küçük bir değişiklik yaptık. Bu sayı yalnızca tamamlanmış indirmeleri gösterir.',
      display_name: {
        label: 'Başlık',
        label_mobile:
          'Transferinizin içeriğinin anlaşılması için bir başlık ekleyin',
      },
      download_status_received_text: {
        zero: 'Henüz indirilmedi',
        one: 'İndirildi',
        other: 'İndirildi',
      },
      edit_display_name: {
        cancel: 'İptal',
        save: 'Kaydet',
        title: 'Başlık',
      },
      received_datetime: 'Alındığı tarihi: %{date}, saati: %{time}',
      received_from: 'Alındığı kişi',
      received_moment: '%{moment} alınan',
      teams: {
        received_by: 'Alan',
        self: 'ben',
        sent_by: 'Gönderen',
      },
      title: 'Başlık',
      set_password: {
        added: 'Eklendi',
        change: 'Değiştir',
        remove: 'Kaldır',
        description:
          'Bu transfere kimlerin erişebileceğini kontrol etmek için bir parola belirleyin.',
        remove_warning: 'Bu transferden parola koruması kaldırılsın mı?',
        yes_remove: 'Evet, kaldır',
      },
      set_expiration: {
        description:
          'Bu transfere erişimi sınırlamak için bir son kullanma tarihi belirleyin.',
        label: 'Son kullanma tarihi',
      },
      anon_upsell_no_account:
        'Bu transfer için indirmeleri süresi dolmadan düzenlemek veya izlemek için ücretsiz <a href="%{href}">kaydolun</a>.',
      anon_upsell_found_account:
        'Bu transfer için indirmeleri süresi dolmadan düzenlemek veya izlemek için <a href="%{href}">oturum açın</a>.',
      anon_upsell_no_account_with_button:
        'Bir hesap oluşturarak bu transferi süresi dolmadan önce düzenleyebilirsiniz.',
      create_free_account: 'Ücretsiz hesap oluşturun',
    },
    transfers: {
      space_used_unlimited: ' %{space} depolama alanı kullanıldı',
      pagename: 'Aktarımlar',
      search: 'dosya adı ara',
      search_results: {
        one: '%{count} arama sonucu',
        other: '%{count} arama sonucu',
        none: 'Sonuç bulunamadı',
        retry:
          'Anlaşılan aramanızla eşleşen bir transfer bulamadık. Tekrar deneyin.',
      },
      space_used: '%{space} / %{totalSpace} kullanıldı',
      selected_text: {
        one: '%{count} aktarım seçildi, toplam boyut %{size}',
        other: '%{count} aktarım seçildi, toplam boyut %{size}',
      },
      last_7_days: 'Son 7 günde gönderildi',
      over_7_days: '7 günden önce gönderildi',
      sort_on: 'Sıralama:',
      size: 'Boyut',
      name: 'Ad',
      date: 'Tarih',
      delete: 'Sil',
      download: 'İndir',
      forward: 'İlet',
      remove: 'Sil',
      select: 'Seç',
      copy_link: 'Bağlantıyı kopyala',
      sent_time_ago: '%{timeAgo} önce gönderildi',
      files: {
        one: '%{count} dosya',
        other: '%{count} dosya',
      },
      confirm_transfer_delete:
        'Bu aktarımı silmek istediğinizden emin misiniz?',
      confirm_forward:
        'Bunun iletilmesi, devam eden aktarımın yerini alacaktır. Devam edilsin mi?',
      confirm_expired_transfer_delete:
        'Bu, dosyaları ve transfer bilgilerini sonsuza dek silecek. Devam edilsin mi?',
      deleting_now: 'Şu anda bunu sizin için siliyoruz',
      deselect_all_transfers: {
        one: 'Tüm aktarımların seçimini kaldır',
        other: '%{count} aktarımın tamamının seçimini kaldır',
      },
      downloads: 'İndirilenler',
      expiration: 'Bitiş tarihi',
      expiration_next: '%{days} gün sonra sona erecek',
      expiration_no_date: 'Bitiş tarihi yok',
      expiration_not_soon: 'Bitiş tarihi yakın değil',
      include_archived_switch_label:
        'Silinen transferlere ait bilgileri dâhil et',
      include_archived_switch_tooltip:
        'Bunlar depolama limitinize dâhil edilmez',
      notify_completed:
        'Transfer tamamlandı. Bu paneli kapatabilirsiniz. İsterseniz bakmaya devam da edebilirsiniz, sorun olmaz.',
      preview: 'Önizleme',
      remove_permanently: 'Bilgileri sonsuza dek kaldır',
      search_placeholder: 'Dosya adı ya da e-posta adresi ile arama',
      select_all_transfers: {
        one: 'Tüm aktarımları seç',
        other: '%{count} aktarımın tamamını seç',
      },
      space_left: '%{totalSpace} toplam alandan %{space} alan kaldı',
      teams_tip: {
        subtitle:
          'Bu sayfa size kendi transfer etkinliğinizi gösterir. Merak ediyorsanız, ekip üyeleriniz de sadece kendi transferlerini görebilirler.',
        title: 'Pro ekibiniz genişliyor…',
      },
      title: 'Gönderilen transferler',
      view_details: 'Ayrıntılara göz at',
      edit_display_name: 'Başlığı düzenle',
      received_time_ago: '%{timeAgo} önce alınan',
      search_title_placeholder: 'Başlık, dosya adı ya da e-posta ile ara',
      see_all: 'Tümünü gör (%{count})',
      sender: 'Gönderen',
      sort_by_title: 'Başlık',
    },
    accountinfo: {
      pagename: 'Hesap bilgileri',
      signed_in_as: '%{name} adıyla oturum açıldı',
      sign_out: 'Oturumu kapat',
      paid_on: 'Ödeme tarihi:',
      no_invoices:
        'Makbuzlarınız burada görülecek ama henüz bir makbuzunuz yok.',
      subscription_info:
        '%{deal} Pro üyeliğiniz %{autorenewal_attempt} tarihinde otomatik olarak yenilenecektir.',
      payment_success: {
        monthly: 'Harika, bir ay için WeTransfer Pro üyesisiniz',
        monthly_renewal: 'Harika, bir ay daha Pro üyesisiniz',
        yearly: 'Harika, bir yıl için WeTransfer Pro üyesisiniz',
        yearly_renewal: 'Harika, bir yıl daha Pro üyesisiniz',
      },
    },
    changepassword: {
      pagename: 'Parolayı değiştir',
    },
    invoices: {
      pagename: 'Makbuzlar',
    },
    reviewbilling: {
      pagename: 'Ödeme bilgilerinizi onaylayın',
      information:
        'Ödeme yönteminizi değiştirmek için aynı zamanda aboneliğinizi yenilememiz gerekecektir',
      information_payment:
        'Sonraki %{period} Pro aboneliği için %{deal} ücret alınacaktır; aboneliğiniz %{expiry} tarihine kadar geçerli olacaktır',
    },
    renewbilling: {
      pagename: 'Bilgilerinizi gözden geçirin ve yenileyin',
    },
    link_downloads_unsubscribe: {
      body: 'Bağlantı transferi indirmeleri ile ilgili bildirimlerinin aboneliğinden çıkabilirsiniz. İndirmeleri Gönderilen panelinizden takip edebileceksiniz.',
      cta: 'Gönderilen transferler panelime git',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Galeriden seçim yapın',
        },
        next_button: 'Her şey hazır!',
        description:
          'Bir arka plan duvar kâğıdı seçin ve profilinizin ve indirme sayfalarınızın nasıl görüneceğine siz karar verin. Çok güzel, değil mi? Kendi duvar kâğıdınızı yükleyebilir veya sunduğumuz birkaç seçeneği kullanabilirsiniz.',
      },
      upload_wallpaper: {
        add_text: 'Bir görsel yükleyin',
        add_description:
          "En iyi sonuçlar için, 2560 x 1600 piksel boyutunda bir görüntü yüklemenizi öneririz. Maksimum dosya boyutu 3 MB'tır.",
        upload_text: 'Bir görsel ya da video yükleyin',
      },
      preview: {
        wallpaper_credits_prefix: 'Duvar kağıdını sağlayan:',
      },
      1: {
        description:
          "&quot;Dosya gönderdiğiniz kişilerin her gönderiminizde neler göreceğini özelleştirin. Kendi WeTransfer sayfanıza sahip olduğunuzda, herkes size %{transfer_limit} transfer gönderebilir, bunun için onlara URL'nizi vermeniz yeterlidir. E-posta adresiniz sayfada gösterilecektir, böylelikle insanlar dosyalarının size ulaşacağından emin olabilir.<br /><br />\nÖncelikle URL'nizi seçin.&quot;",
        next: 'İleri',
        skip: 'Atla',
        warning:
          '<strong>Dikkat,</strong>, bunu yalnızca bir kez belirleyebilirisiniz (baskı yok!)',
        'blurb-1':
          'Birileri dosyalarınızı indirirken profesyonel görünmek ve insanların size transfer göndermesini (daha da) kolaylaştırmak için kendi WeTransfer sayfanızı oluşturun.',
        'blurb-2': 'Öncelikle URL’nizi seçin.',
        welcome: 'Kendi WeTransfer sayfanızla sahne sizin',
        information:
          'Merak etmeyin, bunu daha sonra istediğiniz zaman <strong>Markalandırma</strong> bölümünden değiştirebilirsiniz.',
        description_unlimited:
          "Her dosya gönderdiğinizde insanların ne göreceğini özelleştirin. Ve kendi WeTransfer sayfanızla, herkes size her boyutta transfer gönderebilir; onlara URL'nizi vermeniz yeterlidir. İnsanların dosyalarının size gönderileceğine güvenebilmeleri için e-posta adresiniz sayfada gösterilecektir.<br /><br />\nİlk önce URL'nizi seçin.",
      },
      2: {
        description:
          'Profiliniz için en fazla beş farklı arka plan (veya bizim kullandığımız ifadeyle duvar kâğıdı) seçebilirsiniz.\n \nKendinizi veya markanızı öne çıkarıp merkeze yerleştirin ve dosyalarınızı teslim ederken tarzınızı ortaya koyun',
        pick: 'Galerimizden bir tane seçin',
        title: 'Her transferinizle bir etki bırakın',
        upload: 'Kendi duvar kâğıdınızı yükleyin',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> tamamen hazır. Artık insanların size %{transfer_limit} transfer göndermesi için bu bağlantıyı web sitenize ekleyebilir ya da gidip bir şeyler gönderebilirsiniz.',
        done: 'Bitti',
        title: 'Ne güzel bir profil',
        description_unlimited:
          '<strong>%{customLink}</strong> hazır. Artık insanların size herhangi bir boyutta transfer göndermesi için bu bağlantıyı web sitenize ekleyebilirsiniz— ya da gidip bir şeyler gönderebilirsiniz.',
      },
    },
    contact: {
      add_contact: 'Kişi ekle',
      add_first_description:
        'Dosya gönderdiğiniz e-posta adreslerini buraya da kaydedeceğiz',
      add_to_transfer: 'Transfere ekle',
      remove_from_transfer: 'Transferden çıkar',
      confirm_delete: {
        one: 'Bu kişiyi silmek istediğinizden emin misiniz?',
        other: '%{count} kişiyi silmek istediğinizden emin misiniz?',
      },
      contact_count: {
        one: '%{count} kişi',
        other: '%{count} kişi',
      },
      edit: 'Düzenle',
      mobile: {
        add: 'Kişi ekle',
      },
      no_contacts: 'İlk kişiyi ekleyin!',
      pagename: 'Kişiler',
      remove: 'Sil',
      search_count: {
        one: '%{count} arama sonucu',
        other: '%{count} arama sonucu',
      },
      search_placeholder: 'e-posta adresi, ad veya şirket arama',
      select: 'Seç',
      selected_text: {
        one: '%{count} kişi seçildi',
        other: '%{count} kişi seçildi',
      },
      teams_tip: {
        subtitle:
          'Birilerine bir transfer gerçekleştirdiğinizde, bu kişileri kişi listenize ekleyeceğiz. Ekibinizdeki herkes kendi listesini oluşturabilir.',
        title: 'Pro ekibiniz genişliyor…',
      },
    },
    unsubscribeexpiration: {
      button: 'Aboneliği iptal et',
      button_unsubscribed: "WeTransfer'e geri dön",
      description:
        'E-postalarımızdan bunaldınız mı? Sorun değil! Geçerlilik süresi dolmak üzere olan transferlerle ilgili olarak artık size e-posta göndermeyeceğiz.',
      description_unsubscribed:
        'Geçerlilik süresi dolan transferler hakkında artık e-posta almayacaksınız',
      no_email: 'siz',
      title: 'Hatırlatma e-postalarının aboneliğini iptal et',
      title_unsubscribed: 'Tamamlandı!',
      downloaded: {
        body: 'Tamamdır. Dosyalarınız indirilmişse transferlerinizin süresinin dolmak üzere olduğuna dair hatırlatmaların aboneliğinden çıkabilirsiniz. Bu, kullanıcılar henüz dosyalarınızı indirmediğinde size hatırlatmalar gönderip göndermeyeceğimiz etkilemez.',
        cta: 'Abonelikten çık',
        title:
          '"Dosyalarım indirildi, süresi dolmak üzere olan transferlerle ilgili e-postalara ihtiyacım yok"',
      },
      not_downloaded: {
        body: 'Sorun değil. Dosyalarınızı kimse indirmemiş olsa bile transferlerinizin süresinin dolmak üzere olduğunu bildiren hatırlatmaların aboneliğinden çıkabilirsiniz',
        cta: 'Abonelikten çık',
        title:
          'Süresi dolmak üzere olan transferlerle ilgili e-postalara ihtiyacınız yok mu?',
      },
      pro: {
        body_1:
          'Sorun değil, bu hatırlatmaların aboneliğinden çıkabilirsiniz. Transfer bilgilerinizde transferlerinizin süresinin ne zaman dolacağını halen görebilir ve bitiş tarihlerini ne zaman isterseniz değiştirebilirsiniz.',
        body_2:
          'Hatırlatma: Fikrinizi değiştirirseniz ya da bir konuda takılıp kalırsanız bize <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> adresinden ulaşabilirsiniz - size darılmadık.',
        cta: 'Abonelikten çık',
        title:
          'Süresi dolmak üzere olan transferler hakkındaki e-postalara ihtiyacınız yok mu?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Çerezlerinizi temizlemek istediğinizden emin misiniz?',
        },
      },
    },
    about_plus: {
      checklist: {
        title:
          "Ayda %{price}%{currency} karşılığında hesabınızı hemen Pro'a yükseltin",
      },
    },
    advertise: {
      gallery: {
        preview: 'Önizleme',
      },
      guidelines: {
        advert_static: {
          title: 'Statik duvar kâğıdı',
        },
      },
    },
    billinginfo: {
      pagename: 'Fatura bilgileri',
    },
    help: {
      button_all_answers: 'Daha fazla cevap',
      page_title: 'Hızlı Yardım',
      read_more: 'Devamını okuyun',
      search_button: 'Ara',
      search_placeholder: 'Size nasıl yardımcı olabiliriz?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Yükleniyor...',
    },
    payment_update: {
      bancontact: {
        info: 'Hatırlatma – bilgilerinizin doğruluğunu kontrol etmek için, Bancontact bir kereye mahsus olarak 0,50 € tutarında bir ücret tahsil edecektir',
      },
      confirm_update: 'Onayla',
      ideal: {
        info: 'Hatırlatma – bilgilerinizin doğruluğunu kontrol etmek için, IDEAL bir kereye mahsus olarak 0,01 € tutarında bir ücret tahsil edecektir',
      },
      info: 'Hatırlatma – bilgilerinizin doğruluğunu kontrol etmek için IDEAL sizden bir kereliğine mahsus olarak 0,01 € tutarında bir ücret tahsil edecektir.',
      sofort: {
        info: 'Hatırlatma – bilgilerinizin doğruluğunu kontrol etmek için, SOFORT bir kereye mahsus olarak 1 € tutarında bir ücret tahsil edecektir',
      },
      title: 'Ödeme bilgilerini güncelle',
      update_in_progress: 'Bilgileriniz güncelleniyor...',
    },
    sign_in: {
      account: 'Bir hesabınız yok mu?',
      upgrade: "Hesabınızı WeTransfer Pro'a yükseltin",
    },
    signin: {
      account_cta: 'Bir hesap oluşturun',
      account_item_1: "%{size_limit}'a kadar gönderin",
      account_item_2: 'Transferleri yönetin',
      account_item_3: "%{storage_limit}'a kadar depolayın",
      account_subtitle: 'Ücretsiz',
      plus_cta: "WeTransfer Pro'a geçin",
      plus_item_1: "%{size_limit}'a kadar gönderin",
      plus_item_2: 'Transferleri yönetin',
      plus_item_3: "%{storage_limit}'a kadar depolayın",
      plus_item_4: 'Size ait arka planlar',
      plus_item_5: 'Size özel bir URL',
      plus_item_6: 'Transferleri parolayla koruyun',
      plus_month: '/ay',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Davetiyeyi iptal et',
      },
      invitees: {
        title: 'Davet edildi - yanıt bekleniyor',
      },
      member: {
        action_demote: 'Yöneticilikten çıkar',
        action_promote: 'Yönetici yap',
        action_revoke: 'Ekipten çıkar',
      },
      members: {
        title: 'Ekibinizde',
      },
      no_access: {
        description:
          'Bizi takip etmeye devam edin - hazır olduğunda size bildireceğiz. ',
        title: 'Hay aksi, görünüşe göre bu özellik hâlâ çok gizli. ',
      },
      subtitle: {
        members: {
          one: '%{count} üye',
          other: '%{count} üye',
        },
        pending: '%{pendingCount} davet edildi',
      },
      tip: {
        button: 'Daha fazla bilgi',
        subtitle:
          'Yepyeni Ekipler için Pro özelliğimizle, en iyi WeTransfer deneyimini daha da iyileştirdik! Yeni üyeleri ücretsiz ekleyebilirsiniz. Aşağıdaki süper kolay formu doldurarak ekibinizi kurmaya başlayın – davetinizi kabul etiklerinde işe koyulmaya hazırsınız demektir!',
        title: 'Ekip ruhunda "ben" olmaz...',
      },
      title: 'Ekip',
    },
    transfer_progress: {
      meta: {
        expires_in: '%{expiry} sonra geçerlilik süresi dolacak',
      },
      recipients: 'Alıcı',
      upsell: {
        benefit_one: 'Dosyalarınızın ne zaman indirildiğini görün',
        benefit_three: 'Eski aktarımlarınızı gözden geçirip yeniden gönderin',
        benefit_two: 'Dosyalarınızı kimin indirdiğini görün',
        button: {
          action: 'Daha fazla bilgi',
          cancel: 'Hayır, teşekkürler',
        },
        heading: 'WeTransfer Pro ile transferlerinizi kolayca yönetin',
        title: 'Transfer detaylarınız',
      },
    },
    transferReceived: {
      'empty-description':
        'Burada size yapılan tüm transferleri bulacaksınız - tasalanmayın, bunlar depolama alanınızdan hiç yer kullanmayacak',
      'empty-title': 'Transferleri takip edin',
      empty: {
        description:
          'Burada e-postanıza gönderilen veya size yüklenen tüm transferleri bulacaksınız — endişelenmeyin, bunlar depolama alanınızdan hiç yer kullanmayacak.',
      },
      banner: {
        freeUser: {
          text: 'Kolaylıkla almak için yükseltin. Özel bir URL <strong>adınız.wetransfer.com</strong> ve yüklemeler için markalı sayfa alın.',
          link: 'Daha fazla bilgi',
          cta: 'Hesabınızı yükseltin',
        },
        paidUser: {
          withUrl: {
            cta: 'URL’yi kopyala',
            premium: {
              text: '<strong>%{personalisedUrl}</strong> adresi üzerinden sınırsız transfer alabilirsiniz',
            },
            pro: {
              text: '<strong>%{personalisedUrl}</strong> adresi üzerinden herkes size %{transferLimit} adede kadar transfer gönderebilir',
            },
          },
          withoutUrl: {
            text: "URL'nizi <strong>adınız.wetransfer.com</strong> olarak ayarladığınızda herkes size dosya yükleyebilir.",
            link: 'Daha fazla bilgi',
            cta: 'Markalandırmaya git',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Aboneliği iptal et',
      back: "WeTransfer'e geri dön",
      contact:
        'Psst, takılıp kaldığınız bir şey olursa bize <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> adresinden seslenebilirsiniz, bundan gocunmayız.',
      done: 'Tamamdır!',
      message:
        'Tanıtım e-postası aboneliğinden çıkabilirsiniz - merak etmeyin, önemli olanları almaya devam edeceksiniz.',
      title: 'Gelen kutunuz çok mu meşgul?',
    },
    userinfo: {
      pagename: 'Kişisel detaylar',
    },
    free_onboarding: {
      close: 'Kapat',
      finish_tour: 'Bitti',
      next: 'Sonraki',
      send_files: 'Şimdi dosya göndermeye gidin',
      start_tour: 'Başka neler var bir göz atın',
      step_one: {
        body_1:
          'Hesabınız için kullandığınız e-postayı doğruladığınıza göre, artık her dosya transferinizde tekrar doğrulama yapmanıza gerek yok. Doğrulama kodlarına son!',
        body_2:
          'Tüm gönderilmiş ve alınmış transferlerinizi tek bir yerden takip edin. Dosyalarınızın kaç kez indirildiğini görün. Transferlerinizi tek bir tıklamayla tekrar gönderin, iletin ya da silin.',
        header_1: 'Sadece bir kez doğrulama yapın',
        header_2: 'Transferlerinizi yönetin',
        subtitle:
          'Doğrulama kodlarına ve kayıp dosya indirme bağlantılarına son. Yeni hesabınız size büyük dosya göndermenin en kolay yolunu sunuyor. Hem de ücretsiz.',
        title_1: 'WeTransfer ile <strong>dilediğiniz gibi</strong>',
        title_2: 'dosya gönderin',
      },
      step_three: {
        body_1:
          "İster telefonunuzdaki bir video olsun, ister masaüstünüzdeki bir bağlantı; tüm ilham kaynaklarınızı bir yerde kaydedin. Başlamak için başlatıcıdan (sol üst köşedeki şey) Collect'i açın veya aşağıdaki bağlantıyı kullanın.",
        cta: "Collect'e git",
        title_1: '<strong>Collect</strong> ile',
        title_2: 'yoldayken bile ilhamınızı kaydedin',
      },
      step_two: {
        body_1:
          "Fikirler ortaya atın. Devam eden çalışmalarınızı gösterin. Senkronize kalın. Bir daha başka bir slayt daha formatlamanız gerekmeden. Başlamak için başlatıcıdan (sol üst köşedeki şey) Paste'i açın veya aşağıdaki bağlantıyı kullanın.",
        cta: "Paste'e git",
        title_1: 'Paste® ile <strong>saniyeler içinde slaytlar</strong>',
        title_2: 'hazırlayın',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Portalleri deneyin',
        pill: 'Yepyeni bir özellik',
        text: 'Gerekli onayı almanın daha basit bir yolu olan <strong>portaller</strong> ile tanışın. Müşterilerinizi ve işbirliği yaptığınız kişileri dosyalarınızı görüntülemeye ve en beğendiklerini seçmeye davet edin; indirme gerektirmez.',
        title: 'Çalışmalarınızı paylaşın. Geri bildirim alın. Hepsi bir yerde.',
      },
    },
    not_found: {
      body: '<a href="https://wetransfer.com/">wetransfer.com</a> adresine geri dönün ya da <a href="https://wepresent.wetransfer.com/">yazdığımız hoş şeylerle</a> gözlerinizi şenlendirin.',
      image_alt: 'Yanlış giden bir şeyler oldu',
      title: 'Hay aksi, bu sayfa bulunamıyor.',
    },
    password_and_security: {
      title: 'Parola ve güvenlik',
      'two-factor-authentication': {
        description: {
          enabled: '%{date} tarihinden beri',
        },
        disable: 'Kapat',
        done: 'Bitti',
        enable: 'Aç',
        get_recovery_codes: 'Kurtarma kodları alın',
        next_step: 'İleri',
        recovery_code_action: 'Yeni kodlar oluşturun',
        recovery_code_keep_safe:
          'Her bir kod sadece bir kez kullanılabilir, fakat ihtiyacınız olursa her zaman daha fazla kod alabilirsiniz.',
        recovery_code_need_more:
          'Daha fazla kurtarma koduna mı ihtiyacınız var? İstediğiniz zaman yenilerini oluşturabilirsiniz, ancak unutmayın ki bunu yapmak mevcut tüm kodları geçersiz kılar.',
        recovery_code_title: 'Kurtarma kodlarınız',
        require_password_action: 'Gir',
        require_password_text: 'Devam etmek için parolanızı girin',
        step_one_action: {
          app_store: "App Store'dan indirin",
          google_play: "Google Play'den indirin",
        },
        step_one_label: 'Adım 1/3',
        step_one_text:
          'Telefonunuzda bir kimlik doğrulama uygulamasına ihtiyacınız olacak. Google Authenticator (ya da başka bir uygulama) telefonunuzda mevcutsa ileri butonuna tıklayın.',
        step_one_title: "Google Authenticator'ı indirin",
        step_three_label: 'Adım 3 (hazırsınız!)',
        step_three_text:
          'Giriş yapmanız gerekiyorsa ve telefonunuz yanınızda değilse (bunun gerçekten olduğunu duyuyoruz), bu kurtarma kodlarından birini kullanabilirsiniz. Bu kodları sizin için saklamayacak veya size tekrar göstermeyeceğiz, bu yüzden şimdi onları alıp banka hesabınızın şifresi kadar güvende tuttuğunuzdan emin olun.',
        step_three_text_2:
          'Bu kodları banka hesabınızın şifresi kadar güvende saklayın! Her bir kod bir kez kullanılabilir.',
        step_three_title: 'Kurtarma kodlarını kaydedin',
        step_two_form: {
          error: 'Tüh, bu kod yanlış ya da kullanım süresi geçmiş',
          label: 'Doğrulama kodu',
        },
        step_two_label: 'Adım 2 (yolu yarıladınız)',
        step_two_text:
          'Bu barkodu taratmak için Authenticator uygulamanızı kullanın Uygulama, altı haneli bir doğrulama kodu oluşturacaktır; bu kodu aşağıya girin.',
        step_two_text_mobile:
          'Bu anahtarı Authenticator uygulamanıza girin. Uygulama, altı haneli bir doğrulama kodu oluşturacaktır; bu kodu aşağıya girin.',
        step_two_title: 'Barkodu taratın',
        step_two_title_mobile: 'Anahtarı girin',
        text: {
          protect_account:
            'Hesabınıza ekstra bir güvenlik katmanı eklemek için telefonunuzu kullanın.',
        },
        title: 'İki faktörlü kimlik doğrulama',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: "Paste® ve Collect'in en iyi özelliklerini kullanmak",
      },
      cta: 'Hayır, Pro kalmak istiyorum',
      'cta-2': 'Aboneliğimi iptal et',
      disclaimer: {
        collect: "Collect'te depolama alanınız 200 GB'den 5 GB'ye düşecek",
        paste: "Paste®'de sınırsız deste yerine 3 desteye sahip olacaksınız",
        'team-member':
          'WeTransfer Pro’daki %{currentTeam} ekibinden çıkarılacaksınız.',
        teams:
          "%{amountOfMembers} kişilik ekibiniz WeTransfer Pro'daki %{currentTeam} ekibinden çıkarılacak",
        title:
          'Mevcut aboneliğiniz <strong>%{date}</strong> tarihinde sona erdiğinde:',
        'transfer-expiry': 'Mevcut transferleriniz 28 gün sonra silinecek',
        'transfer-team-member':
          'Ekibin bir parçası olarak transfer gönderip alamayacak, mevcut ekip transferlerini yönetemeyeceksiniz.',
      },
      'password-expiry': {
        title:
          'Transferleri parola ile korumak ve sürelerinin ne zaman sona ereceğini belirlemek',
      },
      personalization: {
        title: 'Kendi WeTransfer sayfanızı kişiselleştirmek',
      },
      portals: {
        text: '%{planName} ile, müşterilerin incelemesi için çalışma paylaşmak üzere <a href="%{href}" target="_blank">portalları</a> kullanabilirsiniz. İndirme gerektirmez.',
        title:
          'Tek bir noktadan çalışmalarınızı paylaşmak ve geri bildirim almak',
      },
      'stay-pro': 'Aboneliği koru',
      'storage-limit': {
        title:
          'Kişi başına %{storage_limit_pro} depolama alanının keyfini çıkarın',
      },
      subtitle:
        'Şimdi iptal ederseniz, %{date} tarihinden sonra şunları yapamayacaksınız:',
      teams: {
        'individual-text':
          'Transferleri birlikte göndermek, almak ve yönetmek için <a href="%{href}" target="_blank">ekip üyelerini davet edin</a> ya da ücretsiz olarak tek başınıza çalışın.',
        'team-member-text':
          'Ekibinizden çıkarılacaksınız ve transferleri artık ekibinizle birlikte gönderemeyecek, alamayacak veya yönetemeyeceksiniz.',
        'team-owner-text':
          '<a href="%{href}" target="_blank">%{amountOfMembers} ekip üyeniz</a> artık birlikte transfer gönderemeyecek, alamayacak veya yönetemeyecek.',
        title: 'Büyük fikirler üzerinde ekip olarak çalışmak',
      },
      title: '%{planName} planından vazgeçmeye gerçekten hazır mısınız?',
      'transfer-limit': {
        text: 'Şu anda %{transfer_limit_free} olan ücretsiz sınırın epey üzerinde, daha büyük transferler gönderebiliyor ve alabiliyorsunuz.',
        title: '100 kat daha büyük transferler göndermek',
      },
      'transfer-unlimited': {
        text: 'Dosya boyutu limiti olmadan transferler gönderebiliyor (ve alabiliyorsunuz). Bu, ücretsiz %{transfer_limit_free} transfer limitinden sonsuz kere fazladır.',
        title: 'İstediğiniz boyutta transfer göndermek',
      },
      'us-price-change': {
        title:
          'Aboneliğinizi iptal ederseniz veya herhangi bir zamanda yeniden etkinleştirmek isterseniz <br/> aboneliğiniz <a href="https://wetransfer.com/pricing" target="_blank">güncellenmiş fiyatlarımız</a> üzerinden yeniden etkinleştirilecektir.',
      },
    },
    pricing: {
      pro: {
        per_person: 'kişi başı',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Hesap oluştur',
        current_plan: 'Mevcut plan',
        sign_up: 'Kaydol',
        switch_premium: "Premium'a geçin",
        switch_pro: "Pro'ya geçin",
        upgrade: 'Yükseltin',
      },
      faq: {
        answers: {
          answer_1:
            "Ödemenizi tamamlar tamamlamaz WeTransfer Pro veya WeTransfer Premium'u kullanmaya başlayabilirsiniz. Ayrıca, ödenmiş faturanızı eklediğimiz bir onay e-postası da göndereceğiz. <br /><br /> \n \nGiriş yaptıktan sonra daha büyük transferler gönderebilecek, portalları kullanmaya başlayabilecek ve hemen kendi WeTransfer sayfanızı oluşturabileceksiniz. Daha önce ücretsiz plandayken gönderilmiş transferleriniz varsa son kullanma tarihlerini istediğiniz zaman değiştirebilirsiniz.",
          answer_2:
            "WeTransfer'ı kullandığınızda, herkes dosyalarınızı indirebilir; oturum açmalarına veya kaydolmalarına gerek yoktur. Sadece Hizmet Şartlarımızı kabul etmeleri gerekir ve onlardan çerezleri kabul etmelerini isteyebiliriz, hepsi bu! <br /><br /> \n \nPortallarda (WeTransfer'in en son özelliği) çalışmalarınızı paylaşmak veya iş birliği yapmak istiyorsanız müşterileriniz ve ortak çalışanlarınızın dosyaları görüntüleme ve seçme, onlara yorum ekleme, onay verme veya dosya indirmeleri için kaydolmaları gerekmez. Ancak insanların sizinle birlikte değerlendirmeler ekleyebilmesini ve portallar oluşturabilmesini istiyorsanız yalnızca Pro veya Premium planınıza ekip üyeleri eklemeniz gerekir.",
          answer_3:
            'Pro veya Premium planda, planınızın transfer boyutu limiti dâhilinde herkesin size dosya gönderebileceği kendi WeTransfer sayfanızı oluşturabilirsiniz. Yani ihtiyaç duyduğunuz büyük dosyaları müşterilerinizden veya ortak çalışanlardan alabileceksiniz ve bunu yapmak için onlara gereken tek şey bir hesap sahibi olmak değil, sayfanızın URL\'si olacak (ama yine de "size para göndermek isteyen yabancı prensler"den sizi koruyabilmemiz için size dosya gönderecek kişilerden e-posta adreslerini doğrulamalarını isteyebiliriz).',
          answer_4:
            "İlk olarak, WeTransfer Pro veya WeTransfer Premium'a kaydolmanız gerekir; ücretsiz plandayken ekip üyeleri ekleyemezsiniz. Ve hangi planı seçerseniz seçin, ekip üyeleriniz de aynı avantajlardan yararlanacaktır (yani örneğin kendiniz Premium hesaptayken bazı ekip üyeleriniz Pro'da olamaz). Ekip üyeleri, WeTransfer sayfanızdan daha büyük transferler gönderip alabilecek ve transferleri tek bir ortak genel bakıştan yönetebilecek. <br /><br /> \n \nEkibiniz için en iyi olan plana kaydolduktan sonra, ekip yönetimi ayarlarınızdan istediğiniz kadar ekip üyesi davet edebileceksiniz. Aboneliğiniz aktifken istediğiniz zaman ekibinize üye ekleyebilir ve ekibinizden üye çıkarabilirsiniz.",
          answer_5:
            "PayPal'ın yanı sıra Visa, Mastercard ve American Express gibi büyük ağların kredi kartlarını kabul ediyoruz. Ayrıca bazı ülkelerdeki diğer çevrim içi ödeme sistemlerini de destekliyoruz. <br /><br />\n \nYinelenen yıllık veya aylık bir aboneliğe kaydolmanız gerektiğinden doğrudan banka havalelerini kabul edemiyoruz. (Bu ilk kez gerçekleşmeden önce sizi bilgilendirmek için bir e-posta göndereceğiz.)",
          answer_6:
            "WeTransfer Premium ile sınırsız depolama alanına sahip değilseniz gönderilen transferlerinizden bazılarını silerek depolama alanını temizlemeniz veya planınızı yükseltmeniz gerekir. Bunu yapana kadar yeni transferler gönderemezsiniz. <br /><br />\n \nWeTransfer'i ücretsiz kullanıyorsanız, 2 GB'a kadar olan tüm transferleriniz 7 gün sonra otomatik olarak silinir. Bu yüzden endişelenmeyin, depolama sınırınızı aşmanız mümkün değildir.",
          answer_6_variant_asterisk:
            'Gönderdiğiniz transferlerden bazılarını silerek depolama alanında yer açmanız veya planınızı yükseltmeniz gerekecek. Bunu yapana kadar yeni transfer gönderemezsiniz. <br /><br />\n\nPremium aboneliğiniz varsa ve 5 TB’a ulaştıysanız destek ekibimizle iletişime geçebilir ve maksimum yıllık 15 TB limitine kadar daha fazla depolama alanı talep edebilirsiniz. <br /><br />\n\nWeTransfer’ı ücretsiz kullanıyorsanız 2 GB’a kadar gönderdiğiniz tüm transferler 7 gün sonra otomatik olarak silinir. Yani endişelenmenize gerek yok. Depolama limitinizi aşmanız mümkün değil.',
          answer_6_variant_limited_storage:
            'Gönderdiğiniz transferlerden bazılarını silerek veya planınızı yükselterek (Premium aboneliğiniz yoksa) bir miktar depolama alanı boşaltmanız gerekir. Bunu yapana kadar yeni transfer gönderemezsiniz. <br /><br />\n\nWeTransfer’ı ücretsiz kullanıyorsanız 2 GB’a kadar gönderdiğiniz tüm transferler 7 gün sonra otomatik olarak silinir. Yani endişelenmenize gerek yok. Depolama limitinizi aşmanız mümkün değil.',
          answer_7:
            "Aboneliğiniz otomatik olarak yenilenecektir (bu ilk kez gerçekleşmeden önce size bir e-posta göndereceğiz), ancak istediğiniz zaman iptal edebilirsiniz. <br /><br /> \n \nWeTransfer'i ücretsiz kullanmaya geçmek için tek yapmanız gereken <strong>Hesap</strong> ayarlarınıza gidip aboneliğinizi iptal etmektir. Siz ve varsa tüm ekip üyeleriniz mevcut abonelik sürenizin sonuna dek Pro veya Premium planınızı kullanmaya devam edebileceksiniz.",
          answer_8:
            "Dünya çapında milyonlarca insan fikirlerini harekete geçirmek için WeTransfer'e ve araç setimize güveniyor. Sadece dosya paylaşım platformumuzda her ay 80 milyon kişi 2 milyar dosya paylaşıyor. <br /><br />\n \nFikirlerinizi saldırı veya istismardan korumak için dosyalarınız aktarıldıklarında (TLS) ve depolandıklarında (AES-256) şifrelenir. Depolandıktan sonra,dosyalarınıza yalnızca gönderici ve alıcıyla paylaşılan benzersiz bağlantılar kullanılarak erişilebilir.",
        },
        questions: {
          question_1: 'Kaydolduktan ve ödeme yaptıktan sonra ne olacak?',
          question_2: 'Alıcılarımın kaydolması gerekiyor mu?',
          question_3:
            'Herhangi birinden daha büyük transferler alabilir miyim? ',
          question_4: 'Ekip üyelerini nasıl eklerim (ve kaldırırım)?',
          question_5: 'Hangi ödeme yöntemlerini kullanabilirim?',
          question_6: 'Depolama limitimi aşarsam ne olur?',
          question_7: 'Nasıl iptal edebilirim?',
          question_8: "WeTransfer'a güvenebilir miyim? Ne kadar güvenlidir?",
        },
        title: 'SSS',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Reklam (ve sanat)',
            custom: 'Kendi çalışmanızı yükleyin',
            feature_1: 'Özel WeTransfer sayfası',
            feature_2: 'Duvar kâğıdı arka planları',
            feature_3: 'Kişiselleştirilmiş WTransfer e-postaları',
          },
          title: 'Markanızı öne çıkarın',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} depolama alanı',
            title: "WeTransfer'den Collect",
          },
          paste: {
            limited_decks:
              '%{pasteDecksLimit} taneye kadar varsayılan Paste logolu deste',
            title: "WeTransfer'den Paste®",
            unlimited_decks: 'Kendi markalandırmanızla sınırsız deste',
          },
          title: 'Yaratıcı araç setinizi tamamlayın',
        },
        expiry: 'Transferlerin süresi %{days} gün sonra sona erer',
        extra_storage: 'Kişi başı ekstra %{storageLimit}',
        monthly_price: 'Kişi başı ayda %{price}',
        portals: {
          features: {
            feature_1: 'Portallar',
            feature_2: 'Gözden geçirmeler',
            feature_3: 'Müşteri markalandırması',
          },
          title: 'Çalışmalarınızı geri bildirim ve onay için paylaşın',
        },
        security: {
          features: {
            feature_1: 'Özelleştirilebilen bitiş tarihleri',
            feature_2: 'Parola korumalı transferler',
            feature_3: 'Veri şifreleme',
            feature_4: 'İki faktörlü kimlik doğrulama',
          },
          title: 'Transferlerinizi güvenceye alın',
        },
        storage_limit: 'Kişi başı %{storageLimit}',
        teams: {
          features: {
            feature_1: 'Ekip üyeleri davet edin',
            feature_2: 'Ortak transfer genel bakışı',
            feature_3: 'Ortak depolama alanı',
            feature_4: 'Ortak markalandırma',
          },
          title: 'Ekip olarak iş teslim edin',
          subtext: {
            text: 'Yalnızca web sitemizden abonelik satın alırsanız desteklenir.',
            learn_more: 'Daha fazla bilgi',
          },
        },
        tooltips: {
          tooltip_1:
            'Gönderdiğiniz tüm transferler depolama alanınızdan sayılır',
          tooltip_10:
            'TLS ve AES-256 şifreleme ile dosyaları güvenli bir şekilde gönderebilir ve saklayabilirsiniz.',
          tooltip_11: 'İndirmeleri izleyin ve transferleri birlikte yönetin',
          tooltip_12:
            'Markalı duvar kâğıtları ve e-postalarla (ekip) çalışmanızı gösterin',
          tooltip_13:
            'Paste sizin için duyarlı renkler, hizalama ve düzenler içeren desteler tasarlayan bir sunum aracıdır.',
          tooltip_14:
            'Collect, cihazlar arasında görüntüleri, videoları, müzikleri ve bağlantıları kaydetmenize ve düzenlemenize olanak tanır',
          tooltip_2:
            'Dosyalarınız başkaları tarafından giriş yapmadan ya da kaydolmadan indirilebilir',
          tooltip_3:
            'Dosyalarınızı kimin indirdiğini (ya da indirmediğini) takip edin',
          tooltip_4: 'Her müşteri ve proje için çalışmanızı düzenleyin',
          tooltip_5:
            'Müşterileri hiçbir şey indirmek zorunda kalmadan dosyaları görüntülemeye ve seçmeye, yorum eklemeye ve onay vermeye davet edin',
          tooltip_6:
            'Portallarınızı her müşteriye göre özelleştirmek için bir logo ve başlık ekleyin',
          tooltip_7:
            'WeTransfer sayfanız, insanların dosyalarınızı indirdiği ve size planınızın dosya boyutu limitleri dâhilinde transferler gönderebildiği yerdir.',
          tooltip_8:
            "Duvar kâğıtları, wetransfer.com'da dosya gönderip alırken arka planda gördüğünüz video ve resimlerdir.",
          tooltip_9:
            'Vay canına, aslında bunları kimsenin okumayacağını düşünüyorduk— yanıldığımızı kanıtladınız. Tebrikler! Ekran görüntüleri @WeTransfer tarafından tvitlenebilir',
        },
        transfer_classic: {
          features: {
            feature_1: 'Transfer boyutu limiti',
            feature_2: 'Depolama',
            feature_3: 'Hesap olmadan indirmeler',
            feature_4: 'İndirmeleri takip edin',
            feature_5: 'iOS uygulaması',
          },
          title: 'Büyük dosyalar gönderin',
        },
        unlimited: 'Sınırsız',
        yearly_price: 'Kişi başı yılda %{price}',
      },
      header: {
        subtitle:
          'İster eğlence için büyük dosyalar gönderiyor ister müşterilerinize iş teslim ediyor olun, WeTransfer ile yaratıcı projeleri ilerletmeye devam edin.',
        title: {
          english_1: 'Sizin fikirleriniz var,',
          english_2: 'bizimse planlarımız',
          general: 'Planlar ve fiyatlandırma',
        },
      },
      plans: {
        billing: {
          discount: '%{percentage} tasarruf edin (ooo, evet!)',
          discount_up_to:
            '%{percentage} oranına kadar tasarruf edin (ooo, evet)',
          discount_up_to_short: '%{percentage} oranına kadar tasarruf edin',
          monthly: 'Aylık faturalandırma',
          yearly: 'Yıllık faturalandırma',
        },
        free: {
          subtitle: 'Arada bir dosya gönderin',
          title: 'Ücretsiz',
          usp: {
            feature_1: "%{transferLimit}'a kadar dosya gönderin",
            feature_2: 'Transferleri doğrulamaya gerek yok',
          },
        },
        premium: {
          subtitle: 'Sınırlama olmaksızın çalışmalarınızı paylaşın',
          title: 'Premium',
          usp: {
            feature_1: 'Transferlerde boyut sınırlaması yok',
            feature_2: 'Sınırsız depolama alanı',
            feature_2_subtitle:
              '*Başlangıç limiti %{storageLimit} büyüklüğündedir ve talebe göre ekstra depolama alanı ekleme seçeneği vardır. Yıllık maksimum %{annualStorageLimit} limiti geçerlidir. Daha fazla bilgi için lütfen <a href="/legal/terms" data-route-type="premium" target="_blank">Hizmet Şartlarımızı</a> kontrol edin.',
            feature_3: 'Sınırsız portal ve gözden geçirme',
          },
        },
        pro: {
          subtitle: 'Düzenli olarak çok büyük dosyalar gönderin',
          title: 'Pro',
          usp: {
            feature_1: "%{transferLimit}'a kadar dosya gönderin ve alın",
            feature_2: 'Kişi başına %{storageLimit} depolama alanı',
            feature_3: '%{portalsLimit} portal, sınırsız inceleme',
          },
        },
        tagline: {
          free: 'para yok, sorun yok',
          monthly: '/ay (kişi başı)',
          yearly: '/yıl (kişi başı)',
          per_person_monthly: 'kişi başına, aylık faturalandırılır',
          per_person_yearly: 'kişi başına, yıllık faturalandırılır',
          tax_included: 'vergi dâhil',
        },
        title: 'Planınızı seçin',
        banner_text: 'Ayda %{discount_amount} tasarruf edin',
        banner_button_text: 'yıllık ödeyerek',
        month: 'ay',
      },
      skip_link: 'Daha fazla özelliğe geçin',
    },
    pro_classic: {
      hero: {
        cta_1: 'Devamını oku',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Fikirler sizden, planlar bizden',
      },
      cta: 'Sadece dosya göndermek istiyorum',
      free_panel: {
        cta: 'Kaydol',
      },
      plan: {
        free: {
          feature_1: "<strong>%{transfer_limit}</strong>'a kadar gönderin",
          feature_2: 'Transfer doğrulamasına gerek yok',
          subtitle_new: 'Ara sıra dosya gönderenler için',
          title: 'Ücretsiz',
        },
        pro: {
          feature_1: "<strong>%{transfer_limit}</strong>'a kadar gönderip alma",
          feature_2: 'Transferlerin bitiş tarihini siz kararlaştırın',
          feature_5: 'Kişi başına 1 TB depolama alanı',
          subtitle_new: 'Profesyoneller ve ekipler için',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Hemen kaydolun',
          descripttion: 'Transferleri takip edin',
          feature_1: '2 GB’a kadar dosya gönderin',
          feature_2: 'Transferleri tek bir genel bakış üzerinden alın',
          title: 'Ücretsiz',
        },
        pro: {
          cta: 'Daha fazla bilgi',
          descripttion: 'WeTransfer’dan en iyi şekilde yararlanın',
          feature_1:
            '%{transfer_size}’a kadar boyutlarda dosya gönderin ve alın',
          feature_2: 'Kişi başı %{storage_size} transfer depolama alanı',
          feature_3: 'Transferleri özel ayarlarla gönderin',
          title: 'Pro',
        },
        title: 'Transferlerin gelen kutunuzda kaybolmasına izin vermeyin.',
      },
      title: "Yeni WeTransfer'in tadını çıkarın",
    },
    teamsettings: {
      invite: {
        cta: 'Ekibi davet et',
        pagename: 'Ekip davet et',
      },
      manage: {
        cta: 'Ekibi yönet',
      },
      members:
        '%{amountOfMembers} ekip üyeniz var. <a href="%{href}">%{cta}</a>',
      no_members: 'Şimdilik sadece siz varsınız! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Ekip ayarları',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Ekip kurun ve transferleri birlikte yapın',
        context:
          'Ortak depolama alanı, markalandırma ve birbirinizin transferlerine erişim ile ekipçe transfer gönderin ve alın.',
        invite_team: 'Ekibi davet et',
        dismiss: 'Belki daha sonra',
      },
      feature_highlight: {
        free_context:
          'Artık gönderilen ve alınan transferleri tek bir basit genel görünüm sayfasından yönetebilirsiniz. Dosyalarınızın indirildiği anı bilin. Transferlerinizi bir tıklama ile yeniden gönderin, iletin veya indirin. İşte bu kadar kolay',
        free_subtitle: 'Tüm transferleriniz tek bir yerde',
        paste_collect_link:
          '<a href="%{pasteUrl}" rel="external">%{pasteName}</a> ya da <a href="%{collectUrl}" rel="external">%{collectName}</a> bölümüne gidin',
        premium_context:
          "Artık her boyutta transfer gönderebilir ve dosyalarınızı indirirken insanların ne göreceğini kendiniz belirlemek için kendi <b>WeTransfer sayfanızı</b> oluşturabilirsiniz. URL'nizi ve duvar kâğıtlarınızı seçmeye hazır mısınız?",
        premium_cta: 'Sayfa oluştur',
        premium_dismiss: 'Belki daha sonra',
        premium_subtitle: 'WeTransfer sayfanızı kurun',
        premium_team_context:
          'Artık ekibinizin <b>özel WeTransfer</b> sayfasından her boyutta transfer gönderip alabilirsiniz.',
        pro_context:
          "Artık tek seferde %{transfer_limit}'a kadar dosya gönderebilir ve insanların dosyalarınızı indirirken ne göreceğini belirlemek için kendi <b>WeTransfer sayfanızı</b> oluşturabilirsiniz. URL'nizi ve duvar kâğıtlarınızı seçmeye hazır mısınız?",
        pro_team_context:
          'Artık ekibinizin <b>özel WeTransfer sayfasından</b> %{transfer_limit} transfer gönderip alabilirsiniz.',
        send_cta: 'Dosya göndermeye git',
        team_subtitle: 'Ekip olarak yaratıcı çalışmalar gönderin',
      },
      marketing: {
        context:
          'Artık sizin hakkınızda biraz bilgi sahibi olduğumuza göre, size biraz da kendi hakkımızda bilgi vermek isteriz. Yaratıcılıkla ilgili hikâyeler ve en son WeTransfer gelişmelerinden haberdar olmak ister misiniz?',
        image_alt_text:
          'Yeni ürün özellikleri, sektör raporları ve yaratıcılık hakkında hikâyeler anlatan WePresent makaleleri dâhil olmak üzere örnek e-posta içeriği.',
        opt_in: 'Evet, lütfen',
        opt_out: 'Hayır, teşekkürler',
        unsubscribe:
          'Daha sonra ne zaman isterseniz abonelikten çıkabilirsiniz—alınmayız.',
      },
      welcome: {
        context:
          'Sizi daha iyi tanımak hizmetlerimizi iyileştirmemize yardımcı oluyor.',
        cta: 'Devam',
        dismiss: 'Geç',
        dropdown_options: {
          architecture: 'Mimari / İnşaat',
          data: 'Veri / Finans / Hukuk',
          design: 'Tasarım / İllüstrasyon',
          education: 'Eğitim / Öğretim',
          marketing: 'Pazarlama / Halkla İlişkiler',
          music: 'Müzik / Ses',
          other: 'Diğer (ve bununla gurur duyuyorum)',
          photography: 'Fotoğrafçılık',
          product: 'Ürün / Yazılım',
          sales: 'Satış / Müşteri ilişkileri',
          video: 'Video / Animasyon',
        },
        free_tier_title: "WeTransfer'e hoş geldiniz, %{name}!",
        placeholder: 'Hmm, bir bakalım...',
        question: 'İlk olarak, alanınız nedir?',
        team_title: '%{name} , ekibe katıldınız!',
        tier_title: 'WeTransfer %{tier} kademesine hoş geldiniz, %{name}!',
        data_opt_in: {
          checkbox_label:
            "WeTransfer'in web sitelerimizde ve dışında size özel reklamlar gösterebilmesi için, paylaştığınız verileri kullanmasına izin verin.",
          tooltip_anchor: 'Bu ne anlama gelir?',
          tooltip: {
            title: 'WeTransfer verilerimi nasıl kullanıyor?',
            p1: 'E-posta adresinizi, size (ve sizin gibi başkalarına) sosyal medya siteleri gibi ziyaret ettiğiniz web sitelerinde WeTransfer reklamları göstermek için kullanırız.',
            p2: 'Ayrıca, size web sitelerimizde daha iyi bir deneyim sunmak için iş alanı bilginizden de yararlanırız.',
            p3: 'Bizimle paylaşmayı seçtiğiniz veriler daima güvendedir.',
            button: 'Tamam',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Çalışma alanınıza başkalarını ekleyin',
      workspace: 'Çalışma Alanı',
      manage_workspace: 'Çalışma Alanını Yönet',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, bir şeyler ters gitti - lütfen yeniden deneyin veya bizimle <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> üzerinden iletişime geçin',
    complete_payment_exception:
      'Hmm, bir şeyler ters gitti. Lütfen tekrar deneyin veya <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> üzerinden bize ulaşın.',
    retrieve_checkout_exception:
      'Hmm, bir şeyler ters gitti - lütfen yeniden deneyin veya bizimle <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> üzerinden iletişime geçin',
    source_id_error:
      'Maalesef bu isteği gerçekleştiremedik. Lütfen tekrar deneyin.',
    three_d_secure: 'Şu anda 3D Secure kartlarını desteklemiyoruz.',
    generic_error:
      'Hmm, bir şeyler ters gitti - lütfen tekrar deneyin veya yardım merkezimiz üzerinden bize ulaşın',
    invalid_file_error:
      'Bu dosya çok büyük veya png ya da jpg formatında değil; farklı bir görüntü deneyin',
    something_went_wrong:
      'Bir hata oluştu. Lütfen yeniden deneyin veya bizimle <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> üzerinden irtibat kurun',
    signin_no_data_exception:
      'Bir hata oluştu. Lütfen kullanıcı adınızı ve parolanızı kontrol edin ve yeniden deneyin',
    signin_exception: 'Üzgünüz, oturumunuzu açamadık. Lütfen yeniden deneyin.',
    signout_exception:
      'Oturumunuzu kapatamadık. Biraz tuhaf. Lütfen bu sayfayı yenileyerek oturumunuzun hala açık olup olmadığını kontrol edin.',
    signup_account_error:
      'Kayıt sırasında bir hata oluştu; lütfen bilgilerinizi kontrol edin ve yeniden deneyin',
    retrieve_account_exception:
      'Bir hata oluştu. Bunu istemeyi sevmiyoruz ama lütfen yeniden deneyin.',
    update_account_error:
      'Üzgünüz, hesap bilgilerinizi güncelleyemedik. Tekrar deneyebilir misiniz?',
    retrieve_subscription_exception:
      'Ödeme bilgilerinizi bulamadık. Lütfen tekrar deneyin.',
    update_subscription_exception:
      'Ödeme bilgilerinizi güncelleyemedik. Lütfen tekrar deneyin veya <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> vasıtasıyla bizimle irtibat kurun.',
    autorenewal_not_supported: 'Bu hesap için otomatik yenileme desteklenmiyor',
    email_background_upload_validation_error:
      'Bu dosya çok büyük veya png ya da jpg formatında değil; farklı bir görüntü deneyin',
    email_background_upload_validation_error_videos:
      'Bu dosya çok büyük veya png ya da jpg formatında değil; farklı bir görüntü deneyin',
    update_password_exception:
      'Üzgünüz, parolanızı güncelleyemedik. Lütfen yeniden deneyin.',
    retrieve_device_exception:
      'Bağlı cihaz bulamadık. Bir tane bile! Lütfen yeniden deneyin.',
    remove_device_exception: 'Bu cihazı kaldıramadık',
    renew_subscription_exception:
      'Hesabınızı şu anda yenileyemedik. Lütfen daha sonra tekrar deneyin.',
    invoices_retrieve_exception:
      'Makbuzlarınızı bulamadık; lütfen tekrar deneyin',
    invoice_download_exception: 'Bu makbuzu indiremedik; lütfen tekrar deneyin',
    image_not_valid: 'Bu görüntü yüklenemiyor',
    update_profile_error: 'Profinizi güncelleyemedik. Lütfen yeniden deneyin.',
    retrieve_profile_exception:
      'Profil ayarlarınızı bulamadık. Lütfen yeniden deneyin.',
    s3_exception: 'Yükleme sırasında bir hata oluştu. Lütfen yeniden deneyin.',
    file_size_limit_reached:
      'Lütfen 3 MB’lik veya daha küçük bir görüntü yükleyin.',
    retrieve_transferlist_exception: 'Aktarım listenizi bulamadık',
    retrieve_transfer_exception: 'Aktarım ayrıntılarınızı bulamadık',
    delete_transfer_exception: 'Bu aktarımı silemedik',
    delete_transfers_exception: 'Bu aktarımları silemedik',
    update_expiry_exception: 'Bu son geçerlilik tarihini güncelleyemedik',
    add_contact_exception: 'Bu kişiyi ekleyemedik',
    complete_last_order_exception: 'Siparişinizi tamamlayamadık',
    edit_contact_exception: 'Bu kişiyi güncelleyemedik',
    remove_contact_exception: 'Bu kişiyi silemedik',
    request_password_reset_exception:
      'Maalesef bu sıfırlama isteğini gerçekleştiremedik. Lütfen yeniden deneyin.',
    request_password_reset_no_user:
      'Bu e-posta adresini tanıyamadık. Lütfen kontrol edin ve yeniden deneyin.',
    reset_password_error:
      'Parolanız sıfırlanırken bir sorun oluştu. Lütfen tekrar deneyin.',
    reset_password_exception:
      'Maalesef parolanızı şu anda sıfırlayamadık. Lütfen yeniden deneyin.',
    reset_password_token_invalid:
      'Bu sıfırlama bağlantısı çalışmadı. Lütfen e-postayla gönderdiğimiz talimatları uygulayın veya baştan başlayın.',
    retrieve_last_order_exception: 'Siparişinizi bulamadık',
    retrieve_ternot_exception:
      'Aktarımınızı bulmakta sorun yaşıyoruz. Lütfen yeniden deneyin.',
    signin_invalid_credentials:
      'Bu e-posta adresi ve şifre eşleşmiyor. Lütfen bir kez daha kontrol edin ve tekrar deneyin.',
    unsubscribe_expiration_exception:
      'Aboneliğiniz iptal edilirken bir sorun oluştu. Lütfen yeniden deneyin.',
    unsubscribe_expiration_invalid_signature:
      'Bu abonelik iptal bağlantısı çalışmadı. Lütfen yeniden deneyin.',
    cancel_subscription_exception:
      'Görünüşe bakılırsa bir şeyler ters gitti ve aboneliğinizi iptal edemedik, lütfen daha sonra tekrar deneyin.',
    payment_cancelled:
      'Hmm, bir şeyler ters gitti. Lütfen tekrar deneyin veya <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> üzerinden bize ulaşın.',
    profile_picture_upload_validation_error:
      'Bu dosya çok büyük veya png ya da jpg formatında değil; farklı bir görüntü deneyin',
    reactivate_subscription_exception:
      'Bir şeyler ters gitti; lütfen tekrar deneyin.',
    retrieve_contactlist_exception: 'Kişi listenizi bulamadık',
    source_retrieve_error:
      'Hmm, bir şeyler ters gitti. Lütfen tekrar deneyin veya <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> üzerinden bize ulaşın.',
    token_error: 'Yanlış giden bir şeyler oldu. Tekrar denemek ister misiniz?',
    update_user_error: 'Bilgileriniz güncellenirken bir sorun oluştu',
    wallpaper_upload_validation_error:
      'Bu dosya çok büyük veya png ya da jpg formatında değil; farklı bir görüntü deneyin',
    wallpaper_upload_validation_error_videos:
      'Tüh, görünüşe bakılırsa videonuz koşullarımıza uymuyor, başka bir tane deneyin',
    declined_contact_bank_error:
      'Üzgünüz, bu ödemeyi işleme alamadık — lütfen bankanızla iletişime geçin',
    invalid_password: 'Parola tanınmadı',
    otp_token_invalid: 'Tüh, bu kod yanlış ya da son kullanım tarihi geçmiş',
    projects_load_exception: 'Şu anda projelerinizi yükleyemiyoruz',
    update_information_throttle:
      'Bilgileriniz güncellenirken bir sorun oluştu. Tekrar denemeden önce %{throttle_time} ara verin.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
    price_general_error_transfer_details:
      'The price could not be updated, please try again',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Ürünler',
        plans_and_pricing: 'Planlar ve fiyatlandırma',
        pricing: 'Fiyatlandırma',
        pro_and_premium: 'WeTransfer Pro ve Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Reklam',
        upgrade: 'Hesap Yükseltme',
      },
      name_1_2019: 'Şirket',
      name: 'Şirket',
    },
    accessibility: {
      aria_label: 'Ana Sayfa',
    },
    home: {
      name: 'Ana Sayfa',
    },
    help: {
      name: 'Yardım',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Aktarımlar',
        contacts: 'Kişiler',
        profile: 'Profile',
        account: 'Hesap',
        received: 'Alınanlar',
        sent: 'Gönderilenler',
        teams: 'Ekip',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Oturumu kapat',
    signin: {
      name: 'Oturum aç',
    },
    branding: 'Markalandırma',
    label: {
      beta: 'Beta',
      new: 'Yeni',
    },
    login: 'Oturum aç',
    logout: 'Oturumu kapat',
    portals: 'Portallar',
    signup: 'Hesap oluştur',
    features: {
      name: 'Özellikler',
      all: 'Tüm özellikler',
      file_sharing: 'Dosya paylaşımı için',
      collaboration: 'Ortak çalışma için',
      security: 'Veri güvenliği için',
      branding: 'Markalandırma için',
      fast_feedback: 'Hızlı geri bildirim için',
    },
    referral: 'Arkadaşlarınıza tavsiye edin',
    switcher: {
      create_free_account: 'Ücretsiz ekleyin',
      just_you: 'Sadece siz',
      team: 'Ekip',
      team_member_count: '%{amountOfMembers} üye',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, internete bağlı değilsiniz',
        begins_space:
          'Boşlukla başlayan dosya adları, dosyaları göndermemize engel oluyor. Lütfen dosya adını değiştirin ve yeniden deneyin.',
        begins_stop:
          'Dosya adı nokta ile başlayan dosyaları gönderemeyiz. Lütfen dosya adını değiştirin ve yeniden deneyin.',
        blocked: "WeTransfer'i yükleyemiyoruz; engellenmişsiniz",
        generic: 'Üzgünüz, aktarımınız sırasında bir sorun oluştu',
        has_blackslash:
          'Adında eğik çizgi olan dosyaları gönderemeyiz. Lütfen dosya adını değiştirin ve yeniden deneyin.',
        has_linebreak:
          'Adında satır kesmesi olan dosyaları gönderemeyiz. Lütfen dosya adını değiştirin ve yeniden deneyin.',
        incorrect_recipient: 'Girdiğiniz e-posta adreslerinden biri yanlış',
        incorrect_sender: 'E-posta adresinizde bir yanlışlık var',
        io_error: 'Dosyalarınızda bir sorun var',
        long_filename:
          '250 karakterden uzun adlı dosyaları gönderemeyiz. Lütfen dosya adını değiştirin ve yeniden deneyin.',
        long_message: 'Bu mesaj çok uzun; lütfen biraz kısaltın',
        missing_default_recipient:
          "Sadece kayıtlı olan WeTransfer Pro e-posta adresleri %{free_transfer_limit}'tan büyük dosyaları alabilirler. Yeniden başlamak için sayfayı yenileyin.",
        no_clipboard: 'Bağlantıyı kopyalamadınız',
        no_files: 'Henüz herhangi bir dosya eklememişsiniz!',
        no_folders: 'Gönderebilmemiz için klasörünüzü sıkıştırmanız gerekiyor',
        no_recipient:
          'Bu dosyaları göndermek istediğiniz e-posta adresine ihtiyacımız var',
        no_sender:
          'Şimdi e-posta adresinize ihtiyacımız var ve başlamaya hazırız',
        too_big:
          'Bir dakika, bir seferde %{upload_limit} üzerinde aktarım yapamayız',
        too_many_recipient:
          'Hay aksi - Limitimiz %{count} kişi. Daha fazlasına mı ihtiyacınız var? Link transferi yapmayı deneyebilirsiniz',
        unavailable: 'Maalesef bu aktarım silindi ve artık kullanılamaz',
        wrong_password:
          'Bu şifre doğru değil. Lütfen yeniden deneyin ve bu aktarımı size gönderen kişiyle iletişime geçin',
        default_title: 'Tüh!',
        duplicate_filename:
          'Aynı addaki çok sayıda dosyayı gönderemiyoruz. Lütfen dosya adını değiştirin ve yeniden deneyin.',
        firstaccept: 'Göndermeden önce onaylamanız gerekiyor',
        not_downloadable:
          'Dosyalarınız alınırken bir sorun oluştu. Lütfen sayfayı yeniden yükleyin ve yeniden deneyin.',
        recaptcha: {
          text: 'Bir şeyler ters gitti. Lütfen tekrar deneyin!',
          title: 'Hay aksi...',
        },
        too_big_text:
          "Bir kerede %{upload_limit} üzerinde transfer yapamazsınız. Pro ile %{plus_limit}'a kadar gönderin. ",
        too_big_title: 'Selam büyük gönderici',
        too_many_files: 'Aynı anda %{count} dosyadan fazlasını gönderemezsiniz',
        too_many_recipient_text:
          'Pro ile 50 kişiye kadar dosya transferi yapabilirsiniz.',
        too_many_recipient_title: 'Kişi sayısı çok fazla',
        unavailable_forward:
          'Maalesef bu aktarım silindi ve artık kullanılamaz',
        verify: {
          button: 'Yeni bir kod lütfen!',
          text: 'Tekrar deneyin ya da yeni bir kod talep edin. ',
          title: 'Hay aksi!',
        },
      },
      buttons: {
        check_out: 'Bir bakış at!',
        help: 'Yardım Merkezi',
        plus: "Pro'yu edinin",
        get_link: 'Bağlantıyı edin',
      },
      tips: {
        change_type:
          'Dosyaları e-postayla gönderin veya istediğiniz gibi paylaşabileceğiniz özel bir aktarım bağlantısı oluşturun',
        contacts:
          'Dosya gönderdiğiniz kişiler otomatik olarak kişi listenize eklenir',
        expiry:
          'WeTransfer Pro ile transferlerinizin geçerlilik sürelerinin ne zaman sona ereceğine siz karar verirsiniz. (Son geçerlilik tarihini transfer gönderildikten sonra da değiştirebilirsiniz!)',
        free_limit:
          "İyi bir haberimiz var, bir seferde %{size}'a kadar aktarım yapabilirsiniz. Daha da iyisi, bu hizmeti istediğiniz sıklıkta kullanabilirsiniz.",
        message:
          'Aktarımınızla birlikte iletmek istediğiniz mesajı buraya ekleyebilirsiniz',
        password:
          'Ek güvenlik için aktarımınızı parola ile koruyabilirsiniz. Parolayı e-postada belirtmiyoruz, bu nedenle doğru kişiye parolayı ulaştırmanız gerekecektir.',
        recipient_limit:
          '%{email_limit} taneye kadar e-posta ekleyin veya bir bağlantı oluşturmak için transfer düğmesinin yanındaki menüyü açın.',
        transfer_history: 'Aktarımınız, aktarım özetinize kaydedildi',
        your_email:
          'Dosyalarınızın ne zaman indirildiğini bildirebilmemiz için kendi e-posta adresinizi buraya yazın',
        link_transfer:
          'Bunun yerine transfer bağlantısı da alabileceğinizi biliyor muydunuz?',
        previews_receiver:
          'Pro kullanıcıları tarafından gönderilen görsellerin önizlemeleri bunlar indirilmeden önce yapılabilir. İçinde ne olduğunu görmek için dosyaya tıklamanız yeterli!',
        previews_sender:
          'Gönderdiğiniz görsellerin önizlemeleri artık bunlar indirilmeden önce yapılabilir',
        vrl_text: 'Şimdi dosyalarınıza onları indirmeden de göz atabilirsiniz.',
        vrl_title: 'Dosya önizlemesi',
        zip_text:
          'Bir klasör mü yolluyorsunuz? Onu sizin için biz sıkıştırırız',
        zip_title: 'Sıkıştırmaya gerek yok',
        add_display_name_tooltip:
          'İnsanların dosyalarınızın neyle ilgili olduğunu bilmeleri için transferinize bir başlık ekleyin. Böylece o dosyayı daha sonra bulmak da kolaylaşacaktır.',
        anonymous_sender: {
          button: 'Bir bağlantı alın',
          text: 'E-posta adresinizi buraya girerseniz dosyalarınız indirildiği de size haber verebiliriz.\n\nBunun gerçekten siz olduğunu bilmemiz için e-postanızı doğrulamanız gerekecek. Her defasında doğrulamak istemiyor musunuz?',
          text_locked_recipient:
            'E-posta adresinizi buraya girerseniz dosyalarınız indirildiği de size haber verebiliriz.\n\nBunun gerçekten siz olduğunu bilmemiz için e-postanızı doğrulamanız gerekecek. Her defasında doğrulamak istemiyor musunuz?',
        },
        prefer_link: {
          button: 'Bir bağlantı alın',
          text: 'E-postanızı doğrulamak istemiyor musunuz? Sorun değil.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Devamını oku',
        previews_sender_learnmore: 'Devamını oku',
      },
      recipient_locked_text:
        'Bu sayfa, sahibinin dosyaları alması içindir. Bu kişi sizseniz oturum açın veya başkasına göndermek için <a href="https://wetransfer.com">wetransfer.com</a> adresine gidin.',
      recipient_locked_title: 'Hatırlatma',
      title: {
        previews_receiver: 'Yeni: görsel önizlemeleri',
        previews_sender: 'Yeni: görsel önizlemeleri',
      },
    },
    download: {
      blocked: {
        link: 'Daha fazla bilgi',
        text: 'Bu transfer rapor edilmiş ve indirilemez',
        title: 'Transfer engellendi',
      },
      title: 'Hazırsanız başlayın',
      expires: 'Geçerliliği %{relative_time} içinde dolacak',
      expires_never: 'Son geçerlilik tarihi yok',
      files: '%{count} dosya, %{size}',
      format: '%{files}・%{expires}',
      expand: 'daha fazla',
      download_link: 'İndirme bağlantısı',
      files_nosize: {
        one: '%{count} dosya',
        other: '%{count} dosya',
      },
      show_all_files_mobile: 'Tüm dosyaları göster',
      zip_information:
        'Tüm dosyaları bir seferde indirdiğinizde bir .zip dosyası alacaksınız; <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">devamını okuyun</a>',
      files_label: 'Dosyalar',
      message: 'Mesaj',
      learn_more: 'daha fazla bilgi',
      expires_in: '%{expiry} sonra süresi dolacak',
      download_all_zip:
        'Tümünü indir tercihi, tüm dosyaları .zip olarak indirir',
      back_to_transfer: 'Transfere geri dön',
      cookie_text:
        'Size en iyi deneyimi sunmak için çerezler kullanıyoruz. Korkmayın, verilerinizi üçüncü taraflara satmıyoruz. <a href="https://wetransfer.com/legal/manage-cookies" rel="external">Veri tercihlerinizi</a> yönetin.',
    },
    preview: {
      open_grid: 'Önizle',
      click_to_open: 'Önizleme için tıklayın',
      grid: 'Bu transferdeki ögeler',
      link: 'Web sitesi',
      not_previewable: 'Önizleme yok',
      now_open: 'Önizleme açık',
      open_link: 'Bağlantıyı yeni sekmede aç',
      open_link_short: 'Bağlantıyı aç',
      overview: 'genel bakış',
      reload: 'Yeniden yükle',
      something_went_wrong: 'Hay aksi, bir sorun oluştu',
      tap_to_open: 'Önizleme',
      toobig_copy:
        'Sadece 50 MB\'a kadar olan görsellerin önizlemesini yapabiliyoruz – <a href="https://wetransfer.zendesk.com/" rel="external">daha fazla bilgiyi burada okuyabilirsiniz</a>',
      toobig_title: 'Of, bu görsel önizleme için çok büyük',
      unsupported_copy:
        'Hangi dosyaların önizlemesini yapabildiğimizi öğrenmek için <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">bu makaleyi</a> inceleyin.',
      unsupported_title: 'Bu dosya için önizleme (henüz) yok',
      visit_website: 'Web sitesini ziyaret edin',
    },
    complete_mobile: {
      email_text:
        'Transfer e-postası gönderildi. Transferiniz %{expires} süreyle indirilebilir',
      link_text: 'İndirme bağlantınızı kopyalayın:',
      email_text_no_expiry: 'Alıcıya e-postası gönderildi',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            "<b>Reklam alanımızın %30'unun sanatçılara ayrıldığını biliyor muydunuz?</b> Çerezlerimizi kabul ettiğinizde, size birkaç sanat eseri, önemsediğimiz bazı amaçlar ve işinize mani olmayan bazı ödüllü reklamlar göstermemize izin vermiş olursunuz. ",
          text: 'Gördüğünüz reklamları kişiselleştirebilmemiz için üçüncü taraf reklam ortaklarımızdan gelen çerezlere de izin veriyor musunuz? ',
          title: 'Çerezlerimiz kültürü besler',
        },
        subtitle:
          "<b>Bu yüzden reklam alanımızın% 30'u sanatçılara ayrılıyor.</b> Çerezlerimizi kabul ettiğinizde, size birkaç sanat eseri, önemsediğimiz bazı amaçlar ve işinize mani olmayan bazı ödüllü reklamlar göstermemize izin vermiş olursunuz. ",
        text: "Web sitemiz, düzgün çalışmasına yardım eden, WeTransfer'ı nasıl kullandığınızı anlamamızı sağlayan ve performansını geliştirmemize yardımcı olan çerezler kullanmaktadır. Gördüğünüz reklamları kişiselleştirebilmemiz için üçüncü taraf reklam ortaklarımızdan gelen çerezlere de izin veriyor musunuz?",
        title: 'Sanatın dağları bile yerinden oynatabileceğine inanıyoruz',
        'title-small': "WeTransfer'e hoş geldiniz",
      },
      'button-accept': 'Kabul ediyorum',
      'button-accept-all': 'Tümünü kabul et',
      'button-ccpa': 'Kişisel Bilgilerin Satışından Vazgeçin',
      'button-cookies-privacy': 'Gizlilik Tercihleriniz',
      'button-reject': 'Hayır, teşekkürler',
      'button-save': 'Kaydet',
      'button-save-and-exit': 'Kaydet ve kapat',
      'ccpa-banner-text':
        'Web sitemizde en iyi deneyimi yaşamanızı sağlamak için çerezleri kullanıyoruz. Korkmayın, verilerinizi üçüncü taraflara satmıyoruz. Yine de vazgeçmek istiyor musunuz? <a href="%{href}">Ayarları yönet</a>',
      'ccpa-body':
        'ABD’de olduğunuz için haklarınız California Tüketici Gizliliği Yasası (CCPA) tarafından korunuyor ve kişisel bilgilerinizin satışını durdurmamızı isteme hakkına sahipsiniz. Bu, kişisel bilgilerinizi veya özel dosyalarınızı açık artırmaya çıkarıp en yüksek teklifi verene satacağımız anlamına gelmiyor. Böyle bir şeyi hiçbir zaman yapmadık ve hiçbir zaman yapmayacağız! Dijital ayak izinizi küçük, güvende ve kontrolünüz altında tutmak için elimizden gelen her şeyi yapıyoruz. Hangi verileri topladığımız ve bunları neden topladığımız hakkında daha fazla bilgiyi <a href="%{href}">Gizlilik Seçenekleriniz</a> bölümünde bulabilirsiniz.',
      'ccpa-donotsell': 'Kişisel bilgilerimi satmayın',
      'ccpa-header': 'Kişisel Bilgilerin Satışından Vazgeçin',
      'ccpa-intro':
        'İnternetin daha iyi bir yer olması için büyük çaba gösteren sorumlu bir teknoloji şirketi olarak verilerinizi üçüncü taraflara satmıyoruz. Ama yine de resmî olarak vazgeçme hakkınız var.',
      'ccpa-variant-test-text':
        'Web sitemizde sorunsuz bir deneyim yaşamanızı sağlamak ve gördüğünüz reklamları kişiselleştirmek için çerezleri kullanıyoruz. <a href="%{href}"> Çerezleri yönet</a>',
      headline: 'Çerezler ve reklam',
      intro:
        'Zarif reklamlarımızdan elde ettiğimiz parayı faturalarımızı ödemek için kullanıyoruz. Dosya paylaşım hizmetimizi ücretsiz olarak sunabilmemiz bu şekilde mümkün oluyor.',
      'manage-cookies': 'Çerezleri yönet',
      'partners-consent': 'Onay Beyanı',
      'partners-features': 'Özellikler',
      'partners-headline': 'Ortaklarımız',
      'partners-text':
        '<p>Aşağıda, performansı izleyip iyileştirebilmemiz için verilerinizi ölçmelerine izin verdiğimiz özenle seçilmiş ortakların alfabetik bir listesi bulunmaktadır.</p>',
      'preferences-headline': 'Çerezleri yönet ',
      'preferences-text':
        "<p>Gizlilik hakkınıza ve verilerinizle ilgili tercihlerinize saygı duyuyoruz. Araçlarımızı kullanırken bazı kişisel bilgilerinizi işlememiz gerekir, ancak iş, teknoloji ve sizinle ilişkimize karşı sorumlu ve değerlere dayalı bir yaklaşıma bağlıyız.</p>\n<p>Bu nedenle, dijital ayak izinizi küçük, güvenli ve kontrolünüzde tutmak için büyük çaba sarf ediyoruz.</p>\n<p> Politikamız gereği verileri yalnızca kesinlikle gerekli olduğunda toplarız ve işleriz. Ancak, hizmetimizi desteklemek ve WeTransfer'in ücretsiz kalmasını istiyorsanız, lütfen bilgileri reklam ortaklarımızla paylaşmamıza izin verin.</p>",
      'preferences-text-allow-cookies':
        'Çerezlere izin vermeniz bize ve/veya ortaklarımıza şunları yapma imkânı sağlar:<br><br>',
      'purpose-description-first-intro':
        'Web sitemizin ve uygulamalarımızın içinde ve dışında ürün tanıtmak için WeTransfer şunları yapabilir: ',
      'purpose-description-first-list':
        "<ul><li>Tıklama davranışı ve ziyaret edilen sayfalar gibi, web sitelerimizle nasıl etkileşim kurduğunuz ile ilgili bilgileri toplamak ve (mümkün olduğunda) bu bilgileri hakkınızda kaydettiğimiz hesabınızda kullandığınız e-posta adresiniz gibi verilerle birleştirmek </li><li> Topladığımız bilgileri size e-posta yoluyla, kendi web sitelerimizde veya uygulamalarımızda ve üçüncü tarafların web sitelerinde veya uygulamalarında teklifler ve promosyonlar sunmak için kullanmak. Örneğin, WeTransfer Pro'yu kullandığınızda diğer ürünlerimizden birini size tanıtabiliriz.</li></ul>",
      'purpose-description-second-intro':
        'Web sitemizin ve uygulamalarımızın içinde ve dışında ürün tanıtmak için ortaklarımız şunları yapabilir: ',
      'purpose-description-second-list':
        '<ul><li>Tıklama davranışı ve ziyaret edilen sayfalar gibi, web sitelerimizle nasıl etkileşim kurduğunuz ile ilgili bilgileri toplamak ve (mümkün olduğunda) bu bilgileri hakkınızda kaydettikleri verilerle birleştirmek </li><li>Topladıkları bilgileri size e-posta yoluyla, kendi web sitelerinde veya uygulamalarında ve birlikte çalıştıkları üçüncü tarafların web sitelerinde veya uygulamalarında teklifler ve promosyonlar sunmak için kullanmak.</li></ul>',
      'purpose-title':
        'Web sitemizin ve uygulamalarımızın içinde ve dışında ürün tanıtmak',
      'switch-by-partners': 'Ortaklar tarafından',
      'switch-by-we-transfer': 'WeTransfer tarafından',
      text: '<p>Web sitemiz, çalışmasına yardımcı olan, onunla nasıl etkileşim kurduğunuzu analiz etmemize olanak tanıyan ve performansını geliştirmemize yardımcı olan <a href="%{href}">çerezler</a> kullanmaktadır.</p>\n<p>Gördüğünüz reklamları kişiselleştirebilmemiz ve ayrıca WeTransfer ve ortaklarımızın ürünlerini web sitelerimizde ve uygulamalarımızda tanıtabilmemiz için reklam ortaklarımızdan gelen çerezlere de izin vermek ister misiniz?</p>',
      'text-panel':
        '<p>Web sitemiz, çalışmasına yardımcı olan, onunla nasıl etkileşim kurduğunuzu analiz etmemize olanak tanıyan ve performansını geliştirmemize yardımcı olan çerezler kullanmaktadır.</p>\n<p>Gördüğünüz reklamları kişiselleştirebilmemiz ve ayrıca WeTransfer ve ortaklarımızın ürünlerini web sitelerimizde ve uygulamalarımızda tanıtabilmemiz için reklam ortaklarımızdan gelen çerezlere de izin vermek ister misiniz?</p>',
      'tos-experiment': {
        'cookie-intro':
          'Harika sanat eserlerini ve ödüllü reklamları keşfederken büyük dosyalar göndermenin en kolay yolu.',
        'cookie-text':
          'Web sitemiz, çalışmasına yardımcı olan, onunla nasıl etkileşim kurduğunuzu analiz etmemize ve performansını iyileştirmemize yardımcı olan çerezler kullanmaktadır.\nÇerezlerimizi kabul ettiğinizde, size kişiselleştirilmiş reklamlar göstermemize izin vermiş olursunuz. "Çerez" kelimesinden yeterince söz ettik mi? (Çerez.)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Misyonumuz, işinize engel olmayan ödüllü reklamlarla dünyayı daha güzel kılmak ve su altı ormanlarının geri kazanılmasına katkıda bulunmaya yardımcı olmaktır.',
          title: 'Çerezlerimiz gezegeni korur',
        },
        subtitle:
          "Çerezlerimizi kabul ederek, gezegene verdiğimiz vaadimizin kapsamını genişletmemize doğrudan yardımcı olabilirsiniz. WeTransfer olarak sadece bu yıl içinde 175.000'den fazla ağaç dikmeyi taahhüt ettik ve daha yeni başlıyoruz. Sadece ödüllü reklamlarımızı deneyimleyerek olumlu bir etki yaratabilirsiniz. ",
        text: 'Web sitemiz, performans ve hizmeti iyileştirmek ve ihtiyaçlarınızı daha iyi anlamak için çerezler kullanır. Üçüncü taraf çerezlerimizi kabul ettiğinizde, biz ve ortaklarımız size web site(leri)miz ve uygulamalarımız üzerinde ve dışında sizi daha çok ilgilendiren reklamlar sunabiliriz.',
        title: 'Fikir transferi ile<b>dünyayı değiştirin.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: "Collect Pro'nun kilidini açın",
      title: 'Hareket halindeyken bile ilhamınızı kaydedip paylaşın',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Daha fazla bilgi',
      title: 'Paste® Pro ve Collect Pro şimdi aboneliğinize dahil',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: "Paste® Pro'nun kilidini açın",
      title: 'Büyük fikirleri şahane sunumlara dönüştürün',
    },
    terms_conditions: {
      experiment: {
        text: 'Devam etmek için lütfen <a href="/legal/terms" data-route-type="plus">Hizmet Koşullarımızı</a> kabul edin.',
        title: "<span class='tc-title-exp'>Neredeyse</span> bitti",
        ustitle:
          "<span class='tc-title-exp'>Büyük dosyaları göndermenin</span> en kolay yoluna hoş geldiniz.",
      },
      title: 'Öncelikle...',
      text: 'Devam etmek için lütfen <a href="/legal/terms" data-route-type="plus">Hizmet Koşulları</a>nı ve <a href="/legal/privacy" data-route-type="plus">Çerez Politikası</a>nı kabul edin. Çerezleri işlevsel ve analitik amaçlı, üçüncü taraf çerezlerini ise reklam amaçlı kullanmaktayız.',
      language: 'Mevcut dil ayarı:',
      button: 'Kabul ediyorum',
    },
    upsell_pricing: {
      text: 'Planları karşılaştırın',
      title: 'Daha büyük transferler mi göndermek istiyorsunuz?',
      receiving: {
        title: "WeTransfer'den maksimum fayda sağlamak ister misiniz?",
      },
    },
    welcome: {
      card1:
        'Tek bir ortak <strong>genel bakışla</strong> %{transfer_limit} transfer gönderip alın',
      card2:
        'Çalışmalarınızı ekibinizin özel <strong>WeTransfer sayfasından</strong> teslim edin',
      card3:
        "<strong>Paste®</strong>'deki desteler ve <strong>Collect</strong>'teki panolar üzerinde işbirliği yapın",
      cta: 'Haydi, başlayalım',
      headline: 'Ekibe katıldınız, <strong>%{first_name}</strong>',
      'opt-in':
        'Yaratıcılıkla ilgili hikayeleri ve en son WeTransfer haberlerini almak istiyorum',
    },
    form: {
      num_files: {
        one: '%{count} dosya eklendi · %{remaining} kaldı',
        other: '%{count} dosya eklendi · %{remaining} kaldı',
      },
      add_files: 'Dosyalarınızı yükleyin',
      more_files: 'Daha fazla dosya ekleyin',
      available_space: '%{size} boyuta kadar ekleyin',
      message: 'Mesaj',
      from: 'E-postanız',
      to: 'Alıcı e-posta adresi',
      other_recipients: {
        one: '+%{count} kişi',
        other: '+%{count} kişi',
      },
      reset_forward: 'İletmeyi iptal et',
      drop_files: 'ya da sürükleyip bırakın',
      files_count: {
        one: '%{count} dosya eklendi · toplam %{fileSize}',
        other: '%{count} dosya eklendi · toplam %{fileSize}',
      },
      select_folder: 'Ya da bir klasör seçin',
    },
    progress: {
      title: 'Aktarılıyor...',
      title_finalizing_one: 'Tamamlanıyor...',
      title_finalizing_two: 'Neredeyse bitti...',
      title_finalizing_three: 'Az kaldı...',
      title_finalizing_four: 'Tamamlanmak üzere...',
      subtitle_finalizing: 'Transfer tamamlanana kadar bu pencereyi kapatmayın',
      title_cancel: 'Bu aktarım iptal edilsin mi?',
      uploaded: '%{sent} / %{total} yüklendi',
      remaining: {
        minutes: {
          zero: '1 dakikadan az kaldı',
          one: 'Yaklaşık 1 dakika kaldı',
          other: 'Yaklaşık %{count} dakika kaldı',
        },
        hours: {
          one: 'Yaklaşık 1 saat kaldı',
          other: 'Yaklaşık %{count} saat kaldı',
        },
      },
      document_title: '%{percentage}% - Aktarılıyor...',
      meta: {
        email: {
          one_file_one_recipient:
            '%{filesCount} dosya %{recipientsCount} kişiye gönderiliyor',
          one_file_other_recipients:
            '%{filesCount} dosya %{recipientsCount} kişiye gönderiliyor',
          other_files_one_recipient:
            '%{filesCount} dosya %{recipientsCount} kişiye gönderiliyor',
          other_files_other_recipients:
            '%{filesCount} dosya %{recipientsCount} kişiye gönderiliyor',
        },
        link: {
          one: '%{count} dosya gönderiliyor',
          other: '%{count} dosya gönderiliyor',
        },
      },
    },
    complete_link: {
      title: 'İşlem tamam!',
      text: 'İndirme bağlantınızı kopyalayın veya <a href="/transfer/progress">içinde ne olduğuna göz atın</a>',
      text_copied: 'Bağlantı panonuza kopyalandı',
      text_manual_copy:
        'Bağlantınız hazır \nPanonuza kopyalamak için %{shortcut} kısayolunu kullanın',
      document_title: 'Tamamdır!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Aktarımınız iletildi',
    },
    complete_email: {
      title: 'İşlem tamam!',
      text: 'Transfer e-postası gönderildi. Transferiniz %{expires} süreyle indirilebilir. <a href="/transfer/progress">İçinde ne olduğuna göz atın</a>',
      text_no_expiry:
        'Transfer e-postası gönderildi. <a href="/transfer/progress">İçinde ne olduğuna göz atın</a>a',
      document_title: 'Gönderilidi!',
      text_no_details:
        'Transfer e-postası gönderildi. Transferiniz %{expires} süreyle indirilebilir.',
      team_discovery_title: 'Transfer gönderildi!',
      team_discovery_text: 'Transferiniz %{expires} boyunca indirilebilecek',
    },
    failed: {
      title: 'Hmm, yanlış giden bir şeyler oldu',
      text: 'Aktarımınız gerçekleşmedi. Lütfen tekrar deneyin.',
    },
    pending: {
      title: 'Neredeyse hazırız...',
      subtitle: 'Hazırlanıyor...',
    },
    downloading: {
      title: 'Dosyalarınız alınıyor...',
      text: 'İndirmeyi hazırlıyoruz',
    },
    downloaded: {
      title: 'İndirme başlatıldı',
      text: 'İşlem tamamlandığında dosyalar bilgisayarınızda olacaktır (genellikle indirilenler klasöründe)',
      download_links:
        'Bu Board\'daki bağlantıların görünmeyeceğini unutmayın – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">devamını okuyun</a>.',
    },
    expired: {
      title: 'Transferin geçerlilik süresi sona erdi',
      text: 'Üzgünüz, bu transferin geçerlilik süresi sona erdi ve artık indirilemez',
    },
    password: {
      title: 'Parolayı girin',
      text: 'Bu aktarımı indirmek için bir parolaya ihtiyacınız var',
    },
    options: {
      transfer_type: 'Gönderme şekli',
      password: 'Parola',
      password_placeholder: 'Parola belirle',
      expiry: 'Geçerlilik',
      expire_in: {
        '1w': '1 hafta',
        '2w': '2 hafta',
        '1m': '4 hafta',
        never: 'Hiçbir zaman',
        '14d': '2 hafta',
        '28d': '4 hafta',
        '365d': '1 yıl',
        '7d': '1 hafta',
        '90d': '3 ay',
      },
      email: 'e-posta',
      link: 'bağlantı',
      email_transfer: 'E-posta transferi gonderin',
      transfer_link: 'Transfer bağlantısı alın',
      appearence: 'Görünüş',
      set_custom_wallpaper: 'Özel duvar kâğıdı ayarla',
    },
    buttons: {
      transfer: 'Aktar',
      forward: 'İlet',
      new_transfer: 'Dosya gönderin?',
      cancel: 'İptal',
      cancel_no: 'Hayır',
      cancel_yes: 'Evet',
      copy_link: 'Bağlantıyı kopyala',
      ok: 'Tamam',
      done: 'Başka gönder?',
      team_discovery_done: 'Yeni transfer gönder',
      retry: 'Yeniden dene',
      continue: 'Devam',
      download: 'İndir',
      download_all: 'Tamamını indir',
      back_to_home: 'Ana sayfaya dön',
      cleanup: 'Aktarımları gözden geçir ',
      download_all_files: 'Tüm dosyaları indir',
      help: 'Yardım Merkezi',
      payment: 'Şimdi yenile',
      complete_order: 'Ödemeye git',
      download_all_experiment: 'Tümünü .zip olarak indir',
      download_experiment: 'Dosyayı indir',
      download_file: 'Dosyayı indir',
      download_zip: 'Tümünü .zip olarak indir',
      get_link: 'Bağlantıyı Edin',
      go_to_transfer: 'Aktarıma git',
      openinapp: 'WeTransfer uygulamasına kaydet',
      openinapp_experiment: 'WeTransfer uygulamasıyla kaydet',
      openincollectapp: 'Collect app ile kaydet',
      get_a_link: 'Bir bağlantı alın',
    },
    account_expired: {
      text: 'Pro hesabınızın tüm avantajlarından yararlanmak için hemen yenileyin veya <a href="#signout">normal hizmetimizi kullanmak için oturumu kapatın</a>',
      title: 'Pro süreniz sona erdi',
    },
    invalid: {
      text: 'Dosyalarınızı bulamadık',
      title: 'Hay aksi...',
      link: 'Daha fazla bilgi al',
    },
    outdated_browser: {
      text: 'WeTransfer çoğu web tarayıcısını desteklemektedir ama bu çok eski bir tarayıcı; lütfen tarayıcınızı güncelleyin',
      title: 'Web tarayıcınız güncel değil',
    },
    spam: {
      text: 'Bu aktarım spam olarak bildirildi ve silindi',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Limiti yükseltin',
      limit: '%{limit}’a kadar ücretsiz',
      remaining: '%{remaining} kaldı',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: "WeTransfer Pro'yu edinin",
      title: 'Parola korumalı aktarımlar kafanızın daha rahat olmasını sağlar',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: "WeTransfer Pro'yu edinin",
      title: 'Aktarımlarınızı yönetmenin daha akıllıca, daha kolay bir yolu',
    },
    upsell_one: {
      bubble: {
        button: "Pro'yu edinin",
        text: 'Dosyalarınızı parola ile koruyun ve transferlerinizin geçerlilik sürelerinin ne zaman sona ereceğine siz karar verin',
        title: 'Aktarımı yükseltmek ister misiniz?',
        text_experiment:
          'Pro ile transferlerinize parolalar ve son geçerlilik tarihleri ekleyebilirsiniz.',
      },
      href: 'https://facebook.com/wetransfer',
      text: "Facebook'ta WeTransfer",
      title: "Facebook'ta WeTransfer topluluğuna katılın",
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: "WeTransfer Pro'yu edinin",
      title: 'WeTransfer profilinizi kişiselleştirin',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: "WeTransfer Pro'yu edinin",
      title: 'Daha büyük, daha iyi, daha güçlü, daha hızlısına sahip olun',
    },
    account_inactive: {
      text: 'Pro aboneliğini kullanmaya başlamak için kaydınızı tamamlayın',
      title: 'Hesabınız \nhenüz aktif değil',
      tiers: {
        text: '%{plan} kullanmaya başlamak için ödemenizi tamamlayın',
        title: 'Aboneliğiniz henüz aktif değil',
      },
    },
    add_items: {
      files: 'Dosyalar',
      folders: 'Klasörler',
    },
    complete: {
      open_panel: '<a href="/transfer/progress">İçindekilere göz atın</a>',
    },
    details: {
      button: {
        dismiss: 'Reddet',
      },
    },
    download_preview: 'Dosyayı indir',
    error: {
      expired: {
        link: 'Destek ekibimize başvurun.',
        text: 'Hay aksi, görünüşe bakılırsa transferinizin süresi bitmiş.\nBunda bir yanlışlık mı var?',
        title: 'Transferin süresi bitti',
      },
    },
    item: {
      details: {
        folder: 'Klasör',
      },
    },
    items: {
      zero: 'boş',
      one: '%{count} öge',
      other: '%{count} öge',
    },
    mobile: {
      button: {
        back: 'Geri',
        cancel: 'Baştan başlayın',
        next: 'İleri',
      },
      email: {
        title: 'E-posta adresleri ekleyin',
      },
      message: {
        placeholder: 'Transferinize bir mesaj ekleyin',
        title: 'Mesaj',
      },
      options: {
        email: 'E-posta gönderin',
        'email-description':
          'Siz transferinizi basit bir e-posta ile gönderiyorsunuz, biz indirildiğinde size haber veriyoruz.',
        link: 'Bir bağlantı edinin',
        'link-description':
          'Dosyalarınızı bir bağlantıya dönüştürün ve dilediğiniz gibi paylaşın.',
      },
    },
    recaptcha: {
      button: '%100 insanım',
      text: 'Sadece robot olup olmadığınızı kontrol etmemiz gerekiyor (alınmayın)',
      title: 'Neredeyse bitti!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Bize yardımcı olun',
      title: 'Çalışma şeklinizle ilgili bir şey sorabilir miyiz?',
    },
    'verification-code': 'Doğrulama Kodu',
    verify: {
      button: 'Transferi Başlat',
      text: 'Doğrulama kodu için gelen kutunuza göz atın ve kodu aşağıya girin',
      title: 'Mesajınız var!',
      'verification-code': 'Doğrulama kodu',
    },
    'account-verification-failed': {
      body: 'E-postanızı doğrulamada sorun yaşıyoruz. Tekrar denemek için yeni bir bağlantı gönder.',
      cta: 'Yeni bir bağlantı gönderilsin mi?',
      title: 'Yanlış giden bir şeyler oldu',
    },
    'cookie-banner': {
      'button-accept': 'Tamam',
      'button-decline': 'Hayır',
      text: 'Web sitesinin çalışmasına, kullanıcılarımızın sitemizle nasıl etkileşime girdiğini analiz etmemize ve geliştirmemize yardımcı olan <a href="%{href}">çerezleri</a> kullanıyoruz. Kişiselleştirilmiş reklamlar alabilmek için üçüncü taraf çerezlerine de izin vermek istiyor musunuz?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'WeTransfer’ı nasıl kullandığınızı anlayabilmek için analitik çerezleri kullanıyoruz. Bu çerezler, yeni özellikler için A/B testi yapmamıza, her şeyin olması gerektiği gibi çalıştığından emin olmamıza, robotları ve istenmeyen e-posta gibi kötü amaçlı davranışları engellememize olanak veriyor. Bu çerezler, kişisel bilgileri işleyen üçüncü taraf çerezleri de içerebiliyor. ',
        title: 'Analitik çerezler',
      },
      clear: {
        'clear-all-cookies': 'Tüm çerezleri temizle',
        description:
          'Çerezlerimizdeki tüm verilerinizi kaldırabilirsiniz. Kalıcı anonimlik talepleri için lütfen <a href="mailto:support@wetransfer.com">destek ekibimizle iletişime geçin</a>.',
        title: 'Çerezleri temizle',
        warning:
          'Çerezleri temizledikten sonra WeTransfer oturumunuz kapatılacaktır. Bu işlem, hesabınızdaki transferleri etkilemeyecektir.',
      },
      functional: {
        description:
          'WeTransfer’da sizin için kusursuz bir deneyim yaratmak üzere işlevsel çerezleri kullanıyoruz. Bu çerezler, Hizmetimizi kullanabilmeniz için gereklidir.',
        title: 'İşlevsel çerezler',
      },
      'not-yet-set':
        'Henüz çerez tercihinizi belirtmemişsiniz gibi görünüyor. Lütfen bu paneli kapatın ve tercihinizi belirleyin. Tercihinizi daha sonra dilediğiniz zaman buradan değiştirebilirsiniz.',
      'save-and-reload': 'Ayarları kaydet',
      tracking: {
        description:
          'Ticari, editoryal ve tanıtım amaçlı çalışmalarımızın başarısını ölçebilmek için Hizmetimizde reklam çerezlerini kullanıyoruz. Markamız ve ürünlerimiz hakkında bilgi veren sayfalara reklam çerezleri yerleştirilmiyor. Reklam çerezleri, örneğin belirli bir reklama tıkladığınızda bunu kaydetmemize olanak veriyor. Üçüncü taraflarca yerleştirilen çerezler diğer alan adlarına ve web sitelerine de yerleştirilirse reklamcılar internetteki davranışlarınızı takip edebiliyor, ancak WeTransfer toplanabilen bu kişisel bilgilerin hiçbirine erişemiyor veya onları kullanamıyor. Bu nedenle, ilgili üçüncü tarafların gizlilik politikalarına bakmanızı öneriyoruz.',
        title: 'Reklam çerezleri',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Hay aksi, bir sorun oluştu',
        'error-email-exists':
          'Hay aksi, görünüşe bakılırsa bu e-posta zaten kullanılmış',
        'throttle-error':
          'Size çok fazla e-posta yolladık. Lütfen yeni bir kod istemeden önce %{throttle_time} bekleyin.',
      },
      back: 'Doğrulama koduna geri dön',
      body: "Bunu doğru anlamış mıyız? WeTransfer'de kullandığınız e-posta bu.",
      email: 'E-posta',
      error: 'Hay aksi, bir sorun oluştu',
      'error-email-exists':
        'Hay aksi, görünüşe bakılırsa bu e-posta zaten kullanılmış',
      submit: 'Tekrar gönder',
      'throttle-error':
        'Üzgünüz, çok fazla deneme yaptınız. Lütfen transferinizi tekrar başlatın.',
      'throttle-error-action': 'Tekrar başla',
      'throttle-error-link':
        'Size çok fazla e-posta yolladık. Lütfen yeni bir e-posta istemeden önce %{throttle_time} bekleyin.',
      title: 'E-postanızı kontrol edin',
    },
    'email-verification-success': {
      body: 'Şimdi herkes transferleri gerçekten sizin gönderdiğinize güvenebilir.',
      free_signup: 'Ücretsiz hesap oluşturun',
      onboarding_body:
        'Çakın bir beşlik, giriş yaptınız! Kendi URL ve duvar kağıtlarınızı seçmeye hazır mısınız?',
      onboarding_title: "WeTransfer Pro 'ya<br/>hoş geldiniz!",
      send_files: 'Dosya gönderin',
      start_onboarding: 'Haydi başlayalım',
      title: 'Hesabınız doğrulandı!',
      upsell: 'Her seferinde e-postanızı yeniden doğrulamak istemiyor musunuz?',
      verified_sender_tooltip:
        'E-postanızın doğrulanmış olması, insanların transferlerin sizden geldiğine inanmasını sağlıyor. Bu e-postayı değiştirmek için <a href="%{href}">kişisel bilgilerinizi</a> güncelleyin.',
      verified_sender_tooltip_icon:
        'E-posta adresinizi doğruladınız. Bu sayede insanlar transferlerin sizden geldiğinden emin olabilecekler.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Hay aksi, bu kod yanlış ya da zaman aşımına uğramış. Kodlar, yollanmalarından itibaren sadece %{expiry_time} süreyle geçerlidirler.',
        'error-expiry-time-action': 'Yeni kod alın',
        'throttle-error':
          'Çok fazla kez yanlış ya da zaman aşımına uğramış kod girdiniz. Lütfen yeni bir kod istemeden önce %{throttle_time} bekleyin.',
      },
      back: 'Geri git',
      body: 'Gerçekten siz olduğunuzdan emin olmak için <strong title="%{account_email}">%{account_email}</strong> adresine bir doğrulama kodu gönderdik. (Spam klasörünüzü kontrol etmeyi unutmayın).',
      body_link:
        'Son bir hızlı kimlik doğrulama adımı daha kaldı.<br/><br/><strong title="%{account_email}">%{account_email}</strong> adresine bir doğrulama bağlantısı gönderdik (Bulamazsanız, istenmeyen e-postalara da bakın).',
      error: 'Tüh, bu kod yanlış ya da son kullanım tarihi geçmiş',
      'error-expiry-time':
        'Hay aksi, bu kod yanlış ya da zaman aşımına uğramış. Kodlar, yollanmalarından itibaren sadece %{expiry_time} süreyle geçerlidirler.',
      'error-expiry-time-action': 'Yeni kod alın',
      resend: 'E-posta almadınız mı?',
      submit: 'Doğrula',
      'throttle-error':
        'Üzgünüz, çok fazla deneme yaptınız. Lütfen transferinizi tekrar başlatın.',
      'throttle-error-action': 'Tekrar başla',
      title: 'E-postanızı onaylayın',
      'verification-code': 'Doğrulama kodunu girin',
    },
    'force-account-verification': {
      body: "WeTransfer'de kullandığınız e-posta adresini doğrulamak için size e-posta yoluyla bir bağlantı göndereceğiz.",
      cta: 'E-posta gönder',
    },
    'marketing-email-prompt': {
      body: "Son bir şey: WeTransfer'den haber ve ürün güncellemeleri almak ister misiniz?",
      skip: 'Hayır.',
      subscribe: 'Evet, gönderin.',
      title: 'Doğrulandınız!',
    },
    'terms_conditions-no-cookies': {
      text: 'Devam etmek için lütfen <a href="/legal/terms?from_home" data-route-type="plus">Hizmet Koşullarımızı</a> kabul edin.',
    },
    mobile_web: {
      ios_banner_prompt: 'Dosyalarınızı WeTransfer uygulamasında alın',
      ios_banner_prompt_send: 'Dosyaları hızla ve kolayca gönderin',
      tnc_subtitle: 'Büyük dosyalar göndermenin en kolay yolu',
    },
  },
  account: {
    legend: {
      plan: 'Plan',
      save: '%%{amount} tasarruf edin',
      subscription: 'Abonelik',
      summary: 'Sipariş özeti',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'E-postanızı doğrulamanızı isteme nedenimiz',
    workspace: {
      default_workspace: '%{name} adlı kullanıcının çalışma alanı',
      your_workspace: 'Çalışma alanınız',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Gizlilik Tercihleriniz',
        subtitle: 'Verilerinizi yönetin',
        p1: 'Konu reklamlarımız olduğunda bile, size her zaman en iyi deneyimi sunmak istiyoruz.',
        p2: 'E-posta adresiniz gibi, paylaşmayı seçtiğiniz verileri, en çok sevdiğiniz içeriği anlamak ve bundan yararlanarak size (ve sizin gibi başkalarına) ihtiyaçlarınıza en uygun WeTransfer reklamlarını göstermek için kullanmak istiyoruz.',
        p3: 'WeTransfer ile oluşturduğunuz ve paylaştığınız her şey sizin özeliniz olarak kalır. Bunları reklamcılık amaçlarımız doğrultusunda okumayız veya kullanmayız.',
        p4: 'Bizimle paylaşmaya karar verirseniz bu bilgiler daima güvende kalacaktır.',
        control_label:
          "WeTransfer'in web sitemizde ve dışında gördüğünüz reklamları özelleştirmek amacıyla, paylaştığınız verileri (e-posta adresiniz ve iş alanınız gibi) kullanmasına izin verin.",
      },
      vertical_nav: {
        terms_of_service: 'Hizmet Şartları',
        privacy_and_cookie_statement: 'Gizlilik ve Çerez Bildirimi',
        your_privacy_choices: 'Gizlilik Tercihleriniz',
        notice_and_takedown_policy: 'Bildirim ve Kaldırma Politikası',
        responsible_disclosure_policy: 'Sorumlu İfşa Politikası',
        advertising_terms_and_conditions: 'Reklam Şartları ve Koşulları',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Kapat ve dosya göndermeye git',
  },
  account_start_screen: {
    'collect-description':
      'İster telefonda, masaüstü bilgisayarda ister tablette olun, tüm ilham kaynaklarınızı tek bir yerde kaydedin.',
    'collect-title': "Collect'e git",
    'paste-description':
      'Kendi kendilerini tasarlayan sunum desteleriyle harika slaytlar hazırlamak an meselesi',
    'paste-title': "Paste®'e git",
    title: 'Üç araç. Tek hesap. Sonsuz olasılıklar.',
    'transfer-cta': 'Haydi yapalım',
    'transfer-description':
      "Birisi dosyalarınızı her indirdiğinde harika bir izlenim bırakın. Kendi URL'nizi ve duvar kağıtlarınızı seçmeye hazır mısınız?",
    'transfer-title': 'Kendinize ait WeTransfer sayfanızı oluşturun',
  },
  account_welcome_screen: {
    'pro-title': 'WeTransfer Pro’ya hoş geldiniz, <strong>%{name}!</strong>',
    accept: 'Evet, lütfen',
    'accept-short': 'Tamam',
    body_1:
      'Yaratıcılığa dair hikayeler ve en son WeTransfer gelişmelerinden haber almak ister misiniz?',
    body_2: '(İstediğiniz zaman abonelikten çıkabilirsiniz)',
    decline: 'Hayır, teşekkürler',
    'decline-short': 'Hayır, teşekkürler',
    title: "WeTransfer'e hoş geldiniz, <strong>%{name}!</strong>",
  },
  cookie_wall_paid: {
    button: {
      accept: 'Çerezleri kabul et',
      deny: 'Çerezleri reddet',
      manage: 'Çerezleri yönet',
    },
    description:
      'Harika bir deneyim sağlamak üzere normal çerezleri ve analitik çerezleri, reklam amaçlı olarak da üçüncü taraf çerezleri kullanıyoruz.',
    heading: 'Büyük dosyaları göndermenin en kolay yolunu keşfedin',
    snippet: 'WeTransfer’a hoş geldiniz',
  },
  dropzone: {
    pro: {
      title: '<span>Bırakın</span> <br>gitsin',
    },
    title: 'Bu fırsat kaçmaz',
    text: 'Yüklemek için dosyalarınızı ya da klasörlerinizi bu pencereye sürükleyip bırakın',
  },
  form: {
    account: {
      billing_address: 'Fatura adresi',
      billing_cta: 'Ödemeye git',
      billing_title: 'Fatura bilgileri',
      legend: {
        details: 'Fatura bilgileriniz',
        coupon_code: 'İndirim kodu ekleyin',
        free_plus: 'Ücretsiz Pro hesabınızı edinin',
      },
      label: {
        year_label: 'Yıllık',
        year_sublabel: 'En hesaplı: %%{discount_rate} tasarruf',
        month_label: 'Aylık',
        month_sublabel: 'Düzenli faturalandırma',
        email: 'E-posta adresi',
        not_required: '(isteğe bağlı)',
        current_password: 'Mevcut parola',
        new_password: 'Yeni parola',
        repeat_new_password: 'Yeni parolayı onayla',
        password: 'Parola',
        password_confirm: 'Parolayı onayla',
        full_name: 'Tam ad',
        company: 'Şirket',
        street_and_number: 'Adres',
        city: 'Şehir',
        zipcode: 'Posta kodu',
        country_code: 'Ülke',
        vat_number: 'KDV',
        coupon_code: 'İndirim kodu',
        family_name: 'Soyadı',
        given_name: 'Ad',
        state_code: 'Eyalet',
      },
      description: {
        password: 'En az 6 karakter içeren bir parola seçin',
        vat_number:
          "Hollanda'daki şirketlerden %21 KDV alıyoruz. Şirketiniz başka bir AB ülkesindeyse, faturanızdan KDV'yi kaldırmak için lütfen şirket bilgilerinizi ve Avrupa vergi numaranızı girin.\n\nŞirketiniz AB KDV bölgesi dışındaysa, yine de fatura bilgilerinize ihtiyacımız olacak, ancak KDV alınmayacaktır.",
      },
      error: {
        email: {
          blank: 'Lütfen e-posta adresinizi girin',
          invalid: 'Lütfen geçerli bir e-posta adresi girin',
          taken: 'Bu e-posta adresi zaten kullanılıyor',
          taken_login:
            'Görünüşe göre zaten bir hesabınız var. <a class="form-notification__message-link" href="%{login_url}">Giriş yapmak ister misiniz?</a>',
        },
        current_password: {
          invalid: 'Parola tanınmadı',
          blank: 'Lütfen mevcut parolanızı girin',
        },
        password: {
          blank: 'Lütfen yeni parolanızı girin',
          too_short: 'Parolanız en az 6 karakter içermelidir',
        },
        password_confirm: {
          blank: 'Lütfen yeni parolanızı onaylayın',
          confirm: 'Bu parolalar eşleşmiyor',
        },
        full_name: {
          blank: 'Lütfen tam adınızı girin',
          too_short:
            'Dikkat, isminiz en az 3 karakterli olmalıdır (üzgünüz JT)',
        },
        street_and_number: {
          blank: 'Lütfen adresinizi girin',
        },
        city: {
          blank: 'Lütfen şehrinizi girin',
        },
        zipcode: {
          blank: 'Lütfen posta kodunuzu girin',
        },
        country_code: {
          inclusion: 'Doğru yazdığından emin olun / farklı bir ülke girin',
          blank: 'Lütfen ülkenizi girin',
        },
        state_code: {
          inclusion: 'Bu bir eyalet mi?',
        },
        vat_number: {
          vat_number: 'Lütfen geçerli bir KDV numarası girin',
        },
        terms_of_service: {
          accepted: 'Devam etmek için lütfen Hizmet Koşullarımızı kabul edin',
        },
        no_results: 'Doğru yazdığından emin olun / farklı bir ülke girin',
        convert: {
          expired:
            'Üzgünüz, bu transferin geçerlilik süresi zaten doldu ve şimdi kaydedilemiyor. WeTransfer Pro kullanıcılarının transferleri istedikleri kadar muhafaza edebileceklerini biliyor muydunuz? Buradan daha fazla bilgi alabilirsiniz.',
        },
        coupon_code: {
          coupon_code: 'Lütfen geçerli bir indirim kodu girin',
        },
        no_state_results: 'Bu bir eyalet mi?',
      },
      complete_order: 'Siparişinizi tamamlayın',
      terms_conditions:
        '<a href="/legal/terms" %{options}>Hizmet Koşulları</a>\'nı kabul ediyorum ve <a href="/legal/privacy" %{options}>Gizlilik \'ve Çerez Bildirimi</a>ni okudum',
      signup_for_plus: "WeTransfer Pro'ya Kaydolun",
      account_cta: 'Haydi başlayalım',
      signup_for_account: 'Bir WeTransfer Hesabı için kayıt yaptırın',
      'email-verification-not-verified-link':
        'Lütfen e-posta adresinizi doğrulayın. Size gönderdiğimiz e-postayı kontrol edin ya da <button type="button" class="button button--link">yeni bir e-posta</button> isteyin.',
      'email-verification-resend': {
        error: 'Hay aksi, bir sorun oluştu',
        info: 'Yeni kod gönderildi! Lütfen gelen kutunuzu kontrol edin',
        info_link:
          'Yeni e-posta gönderildi! Lütfen gelen kutunuzu kontrol edin.',
        'throttle-error':
          'Size çok fazla e-posta yolladık. Lütfen yeni bir kod istemeden önce %{throttle_time} bekleyin.',
      },
      'force-account-verification': {
        message:
          'Gerçekten siz olduğunuzu anlamamız için lütfen e-posta adresinizi doğrulayın.',
      },
      marketing_opt_in:
        'WeTransfer haberlerini ve ürün güncellemelerini almak istiyorum',
      sso: {
        header: 'Kişisel bilgiler',
        password_reset: {
          button: 'E-posta gönder',
          instructions:
            'Biraz değişikliğe mi ihtiyacınız var? Mesela parolanızda? Hemen halledebiliriz. Aşağıdaki düğmeye basmanız yeterli, <span>%{email}</span> adresine parola değiştirme bağlantısını içeren bir e-posta göndereceğiz.',
          success: 'E-posta gönderildi! Gelen kutunuzu kontrol edin.',
          title: 'Parolanızı değiştirin',
        },
        wrong_user: 'Bu siz değil misiniz? Oturumu kapatın',
      },
    },
    payment_cancel: {
      submit: 'Onayla',
      client_request:
        "WeTransfer'i kullanmamı bir müşteri istemişti ve artık ihtiyacım yok",
      different_tool: 'Başka bir araç buldum',
      extra_features: 'Bu ürünün sunmadığı ekstra özelliklere ihtiyacım var',
      not_enough_storage: 'Benim için yeterli depolama alanı yok',
      not_often_large_files: 'Yeterince sık büyük dosyalar göndermiyorum',
      other: 'Diğer',
      other_more: 'Bize biraz daha bilgi verebilir misiniz?',
      skip: 'Geç ve aboneliği iptal et',
      temp_project:
        'Sadece geçici bir proje için büyük dosyalar göndermem gerekti',
      too_expensive: 'Çok pahalı olduğunu düşünüyorum',
    },
    payment_cancel_reason: {
      skip: 'Geri bildirim vermek istemiyorum',
    },
    profile: {
      label: {
        profile_title: 'Profil adı',
        wallpaper_link: 'Duvar kağıtlarının bağlantılandırılacağı web adresi',
      },
      error: {
        subdomain_name: {
          too_short:
            "Az ama öz olmasının iyi olduğunu biliyoruz ama WeTransfer URL'nizin en az 2 karakter uzunluğunda olması gerekiyor",
          domain_name: 'Üzgünüz, bu ad zaten kullanılıyor',
          invalid:
            "Ooo, bu pek tuhaf görünüyor - WeTransfer URL'niz sadece harfler ve sayılar (ve aralarında bir tire) içerebilir",
          taken: 'Üzgünüz, bu adı birileri zaten kapmış',
        },
        subdomain: {
          too_short: 'En az iki karakter olmalı',
          too_long: 'Bir dakika, 63 karakterden kısa olmalı',
          invalid:
            'Bir dakika, bu çok tuhaf görünüyor - WeTransfer URL’niz sadece harfler ve sayılar (veya aralarında bir tire) içerebilir',
          domain_name: 'Bu URL zaten alınmış',
          taken: 'Bu URL zaten alınmış',
        },
        default_recipient_email: {
          invalid: 'Lütfen geçerli bir e-posta adresi girin',
        },
        wallpaper_link: {
          invalid: 'Lütfen geçerli bir web adresi girin',
        },
      },
      success: {
        subdomain: {
          updated: 'URL’niz güncellendi',
          available: 'İyi haber, bu URL kullanılabilir',
        },
      },
      change_background: 'Arka planı yükle',
      delete_avatar: 'Profil resmini sil',
      delete_background: 'Arka planı sil',
      description: {
        title:
          'Sayfada hiçbir şeyin kesilmemesi için en fazla 150 karakter kullanın',
        wallpaper_link:
          'Duvar kağıtlarınız bu web adresiyle bağlantılı olacaktır',
        recipient_email_locked:
          'Profiliniz üzerinden gönderilen dosyalar yalnızca bu e-posta adresine gidecektir',
      },
      upload_avatar: 'Profil resmini yükle',
      use_email_background_checkbox_label:
        'Profilimden gönderilen tüm aktarımlar için bu duvar kağıdını kullan',
      account_email_checkbox: 'E-posta adresim profilimde gösterilsin',
      default_recipient_email_info:
        'Bu e-posta adresini <a href="/account"> kişisel bilgiler</a> bölümünden değiştirebilirsiniz',
      change_subdomain: {
        message:
          'URL, <a href="%{url}">%{subdomain}.wetransfer.com</a> olarak değiştirilsin mi? Önceki URL’niz hemen kullanılabilecektir.',
        confirm: 'Evet, URL’yi değiştir',
        cancel: 'Geri git',
      },
    },
    fill_in_password: 'Bu değişiklikleri kaydetmek için parolanızı girin',
    select_all: 'Tamamını seç',
    deselect_all: 'Tamamının seçimini kaldır',
    save_changes: 'Değişiklikleri kaydet',
    save: 'Kaydet',
    submitting: 'İşleniyor...',
    cancel: 'İptal',
    forward: 'İlet',
    proceed: 'Devam',
    delete: 'Sil',
    onboarding: {
      placeholder: {
        subdomain_name: 'profil-adınız',
      },
      validated: {
        subdomain_name: 'İyi haberimiz var; bu alan kullanılabilir',
      },
    },
    confirm_leave:
      'Bu sayfadan ayrılmak ve kaydedilmeyen değişiklikleri kaybetmek istediğinizden emin misiniz?',
    unsaved_changes:
      'Sayfadan çıkılsın mı? Kaydedilmemiş değişiklikleri kaybedeceksiniz.',
    contact: {
      add_contact: 'Kişi ekle',
      error: {
        email: {
          duplicate: 'Bu e-posta adresi zaten kişi listenizde',
          invalid: 'Lütfen geçerli bir e-posta adresi girin',
        },
      },
      label: {
        company: 'Şirket',
        email: 'E-posta adresi',
        name: 'Ad',
      },
    },
    error: {
      current_password: {
        blank: 'Lütfen mevcut parolanızı girin',
        invalid: 'Parola tanınmadı',
      },
      email: {
        blank: 'Lütfen e-posta adresinizi girin',
        duplicate: 'Bu e-posta adresi zaten kişi listenizde',
        invalid: 'Lütfen geçerli bir e-posta adresi yazın',
        taken: 'Bu e-posta adresi zaten kullanılıyor',
      },
    },
    leave: 'Ayrıl',
    resetpassword: {
      button: {
        request_submit: 'Bana e-posta gönder',
        reset_submit: 'Yeni parolayı kaydet',
      },
      label: {
        confirm_new_password: 'Yeni parolayı onayla',
        email: 'Eposta adresi',
        new_password: 'Yeni parola',
      },
      legend: {
        request_description:
          'Giriş yapamıyor musunuz? Parolanızı sıfırlamak ve tekrar işleri yoluna koymak için gereken talimatları göndereceğiz.',
        request_title: 'Şifrenizi mi unuttunuz?',
        reset_description: 'Kullanacağınız yeni parolayı girin',
        reset_title: 'Yeni parola belirle',
        request_description_success_or_article:
          'WeTransfer hesabınız varsa size parolanızı sıfırlamanız için talimatlar gönderdik. Birkaç dakika içinde bir e-posta almazsanız bu <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">Yardım Merkezi makalesine</a>  göz atın.',
      },
    },
    signin: {
      button: {
        submit: 'Oturum aç',
      },
      label: {
        email: 'E-posta adresi',
        password: 'Parola',
        remember_me: 'Beni hatırla',
      },
      link: {
        forgot_password: 'Şifrenizi mi unuttunuz?',
      },
      title: 'Oturum aç',
    },
    stay_on_page: 'Sayfada kal',
    close_panel: 'Kapat',
    go_back: 'Geri git',
    labels: {
      email: 'E-posta adresi',
    },
    plan: {
      change: {
        month: 'Aylık (%{price}%{currency})',
        title: 'Aboneliği değiştir',
        year: 'Yıllık (%{price}%{currency})',
      },
      change_plan: 'Ödeme planını değiştir',
      month: {
        copy: 'Düzenli faturalandırma',
        label: 'Aylık',
        'label-payment': 'Aylık ödeme',
        'sub-label': 'Her ay bir fatura',
        title: 'WeTransfer Pro: Aylık ödeme',
      },
      title: 'Fikirlerinize hak ettikleri premium değeri verin',
      year: {
        discount: '%%{rate} tasarruf edin (evet)',
        'label-payment': 'Yıllık ödeme',
        'sub-label': 'Bu %17 tasarruf demek. Harika!',
        title: 'WeTransfer Pro: Yıllık ödeme',
      },
      your_order: 'Siparişiniz',
    },
    save_and_continue: 'Kaydet ve devam et',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Devam etmek için parolanızı girin',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Şimdi değil',
        true: 'WeTransfer uygulamasında aç',
      },
      headline: 'Daha büyük düşünün!',
      headline2: 'Dosyalar uygulamada görüntülensin mi?',
      subheader: 'WeTransfer Pro ile 200 GB gönderip alabilirsiniz',
      subheader2:
        'Dosyaları indirmeden önce görüntüleyin. Transferler gönderin ve alın, indirmeleri takip edin ve bildirimler alın.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        '%{tier} hesabınızın sunduğu tüm avantajlardan yararlanmaya devam etmek için aboneliğinizi hemen yenileyin',
      account_expired_title_tier: '%{tier} hesabınızın geçerlilik süresi doldu',
      account_inactive_title_tier: '%{tier} için hazırsınız',
      account_inactive_action: 'Evet, devam et',
      account_inactive_subtitle:
        'Tamamlamanıza sadece son bir adım kaldı. Fikrinizi mi değiştirdiniz? Sorun değil—',
      account_inactive_title: 'Pro olmaya hazır mısınız?',
      account_subscription_action: 'Şimdi yenile',
      account_subscription_expired: 'Pro hesabınızın süresi sona erdi',
      account_subscription_subtitle:
        'Aktarımlarınızı, kişisel duvar kağıtlarınızı ve web adresinizi korumak için şimdi yenileyin. Aksi halde kısa süre içinde silinecektir.',
      account_expired_action: 'Şimdi yenile',
      account_expired_subtitle:
        'Pro hesabınızın avantajlarından yararlanmaya devam etmek için hemen yenileyin',
      account_expired_title: 'Pro hesabınızın süresi sona erdi',
      expired_transfer_subtitle:
        'Dosyalar artık mevcut değil. Bilgilerini <a>buradaki</a> transfer genel görünümünden kaldırabilirsiniz.',
      expired_transfer_title: 'Bu transferin geçerlilik süresi doldu',
      account_email_verify_logged_out:
        'E-postanızı doğrulamak için lütfen giriş yapın',
      account_inactive_sublink: 'siparişinizi iptal edin.',
      email_unverified_mobile_cta: 'Doğrulamaya hazır',
      email_unverified_text:
        "%{email} adresine bir doğrulama kodu gönderdik. <a href='%{href}'>Bu siz değil misiniz?</a>",
      email_unverified_text_link:
        "%{email} adresine bir e-posta gönderdik. <a href='%{href}'>Bu siz değil misiniz?</a>",
      email_unverified_title: 'Lütfen e-posta adresinizi doğrulayın',
      'force-account-verification': {
        body: 'Gerçekten siz olduğunuzu doğrulamak için size e-postayla bir bağlantı yollayacağız.',
      },
      'receiving-email':
        'Dikkat! Profilinizde %{receiving_email} değişti. Bu, yeni transferlerin yalnızca %{account_email} adresine gönderilmişlerse transferlere genel bakış bölümünde görüneceği anlamına gelir. Bunu değiştirmek için <a href="/account">kişisel bilgiler</a>inizi istediğiniz zaman güncelleyebilirsiniz.',
    },
    design:
      'Burada birkaç değişiklik yaptığımızı muhtemelen fark etmişsinizdir! Bunların büyük kısmı sizlerin görmek istediğinizi söylediğiniz şeyler. Yeni ve (bize göre) iyileştirilmiş siteyi keşfetmenin keyfini çıkarın ve geri bildirimlerinizi bize buradan gönderin.',
    loading_error:
      'Şu anda bu sayfanın yüklenmesinde sorun var. \nDenemeye devam edeceğiz veya kendiniz de <a href="%{path}">sayfayı yenilemeyi deneyebilirsiniz</a>.',
    redesign_notice:
      'Burada <a href="/about/redesign">birkaç değişiklik yaptığımızı</a> fark etmiş olabilirsiniz. Bunların büyük kısmı, görmek istediğinizi söylediğiniz şeyler. Bu yüzden yeni ve iyileştirilmiş siteyi keşfetmenin keyfini çıkarın ve lütfen <a href="/contact" rel="external">geri bildirimlerinizi buradan bize gönderin<a/>.',
    return_to: '%{pageName} sayfasına geri dön',
    close: 'Paneli kapatın',
    cookie: {
      accept: 'Tamam',
      text: 'Çerez kullanmaktayız. <a href="/legal/terms">Yasal maddeleri</a> okuyun (yemek tarifleri içermez).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Kariyer',
      press: 'Basın',
      terms: 'Koşullar',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Hesabınızı yükseltin',
    free_limit:
      "Tek seferde 2 GB'tan fazla gönderemezsiniz. Daha büyük transferler göndermek ister misiniz?",
    compare_plans: {
      button: 'Planları karşılaştırın',
      text: "Tek seferde 2 GB'ı aşan transfer göndermek için planınızı yükseltebilirsiniz.",
      title: 'Gönderecek daha fazla dosyanız mı var?',
    },
    mobile: {
      cta: 'Daha fazla bilgi',
      header: "WeTransfer'den en iyi şekilde yararlanın",
      upsell_enjoy: 'Daha fazla depolama alanının keyfini çıkarın',
      upsell_one: 'Daha büyük transferler gönderin',
      upsell_two: 'WeTransfer sayfanızı kişiselleştirin',
    },
    pro_limit:
      "Tek seferde 200 GB'tan fazla gönderemezsiniz. Her boyutta transferler göndermek ister misiniz?",
  },
  upsell_tiers_one: {
    text: 'Transferleriniz için parolalar ve bitiş tarihleri belirlemek ister misiniz?',
  },
  upsell_tiers_three: {
    text: 'Tek seferde %{email_limit} taneden fazla e-posta adresine transfer göndermek ister misiniz?',
    title: 'Bu biraz fazla oldu',
  },
  browser: {
    assets_failed: {
      text: 'Web sitemizin bazı önemli bölümlerini yükleyemedik.\nGüvenlik duvarınız, proxy’niz veya tarayıcı ayarlarınız tarafından engellenmiş olabilirler.\nSayfayı yenilemeyi deneyin veya <a href="https://wetransfer.zendesk.com" rel="external">yardım merkezimiz</a> üzerinden bizimle iletişime geçin.',
      title: 'Hay aksi...',
    },
    javascript_needed:
      'WeTransfer’ı kullanmak için JavaScript’i destekleyen bir tarayıcınız olmalıdır',
  },
  languages: {
    en: 'İngilizce',
    nl: 'Hollanda',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Bu teklif %{end_date} tarihine kadar geçerlidir. İndirim %{user_tier} aboneliğinizin ilk yılı için geçerlidir, sonrasında abonelik tam fiyat üzerinden %{yearly_amount}/%{billing_period} olarak yenilenecektir.',
    },
    modal: {
      title: 'Yıllık Pro aboneliğinde %%{discount_amount} indirim',
      subtitle: 'İndirim kodu: %{coupon_code_name}',
      text_content:
        'Bu kadar. Hepsi bu. Yıllık Pro planında size %%{discount_amount} indirim veriyoruz.',
      argument: {
        size_limit: '200 GB’lık dosya transferi gönderin ve alın',
        storage_size: '1 TB depolama alanının keyfini çıkarın',
        unlimited_review: 'Sınırsız inceleme oluşturun',
      },
      cta_label: 'İndirim talep edin',
      dismiss_label: 'Şimdi değil',
    },
    banner: {
      title:
        "WeTransfer Pro'da bir yıllık %%{discount_amount} indirim alın - bu şimdiye kadarki en iyi fırsatımız",
      cta_label: 'Yükseltin',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: '%{first_recipient_email} ile ekip olarak transfer yapın',
      subtitle:
        'Ekibinizi %{user_plan} planınızda transfer gönderip almaya davet edin.',
      list: {
        overview_item: 'Transferlere ortak genel bakış',
        storage_limit_item:
          'Kişi başı ekstra %{storage_limit} ortak depolama alanı',
        branding_item: 'Ortak ekip markalandırması',
        subscription_item: 'Ortak abonelik ve faturalandırma',
      },
      cta: 'Ekibi davet et',
      dismiss_button: 'Bugün değil',
    },
    second_viewing: {
      title: '${first_recipient_email} ile ekip olarak transfer yapın',
      subtitle:
        'Ekibinizi %{user_plan} planınızda transfer gönderip almaya davet edin.',
      list: {
        overview_item: 'Transferlere ortak genel bakış',
        storage_limit_item:
          'Kişi başı ekstra %{storage_limit} ortak depolama alanı',
        branding_item: 'Ortak ekip markalandırması',
        subscription_item: 'Ortak abonelik ve faturalandırma',
      },
      cta: 'Ekibi davet et',
      dismiss_button: 'Sonsuza kadar saklayın',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  custom_wallpaper: {
    set_custom_wallpaper: 'Özel duvar kâğıdı ayarla',
    set_custom_wallpaper_description:
      'İnsanlar dosyalarınızı indirdiğinde onlar üzerinde harika bir izlenim bırakmak için bu transfere kendi duvar kâğıdını verin—endişelenmeyin, bu sizin ',
    default_settings: 'varsayılan ayarlarınızı değiştirmez',
    upload: 'Yükle',
    reset_default: 'Varsayılana sıfırla',
    survey_link: 'Ne düşündüğünüzü bize bildirin',
    file_rules:
      'JPEG/PNG %{minWallpaperWidth} x %{minWallpaperHeight}, maks. %{maxUploadSize} MB',
    storage_size_max: 'maksimum',
    pop_over: {
      new_feature: 'Yeni özellik',
      try_now: 'Hemen deneyin',
      not_today: 'Bugün değil',
      hide_forever: 'Sonsuza kadar saklayın',
      hint: 'Hey, bu ayarları değiştirmeden herhangi bir transfere kendi duvar kâğıdını verebilirsiniz—tek yapmanız gereken, bir transfer göndermeden önce özel bir duvar kâğıdı ayarlamak.',
      introductory_upsell:
        'Hey, artık bu transfere kendi duvar kâğıdını verebilirsiniz.',
    },
  },
  notification: {
    update_account: 'Hesabınız güncellendi',
    update_password: 'Parolanız güncellendi',
    update_subscription: 'Ödeme planınız güncellendi',
    update_profile_success: 'Profiliniz güncellendi',
    link_copied: 'Bu bağlantı panonuza kopyalandı',
    copy_link_manual: 'Bağlantı seçildi, %{shortcut} ile kopyalayın',
    delete_transfer_success: 'Bu aktarım silindi',
    delete_transfers_success: 'Aktarımlar silinmiştir',
    update_expiry_success: 'Son geçerlilik tarihi güncellendi',
    onboarding_success:
      'Aktarım özeti, kişiler, profil ayarı ve diğer özellikleri burada bulabilirsiniz',
    add_contact_success: 'Bu kişi eklendi',
    edit_contact_success: 'Bu kişi güncellendi',
    remove_contact_success: 'Bu kişi silindi',
    already_signed_in: 'Giriş yaptınız',
    cancel_subscription_success:
      'Gittiğinize üzüldük - aboneliğiniz iptal edildi.',
    collect_app_banner_desc:
      'Collect app ile dosyaları önizleyin, kaydedin ve yönetin',
    contact_added_confirmation: 'Kişi aktarımınıza eklendi',
    contact_recipient_locked_text:
      'Bu sayfa, sahibinin dosyaları alması içindir. Başka birine mi gönderiyordunuz?',
    forward_ready: 'Aktarımınız iletilmeye hazır',
    mobile_app_banner_desc:
      'Uygulamamızla dosyaları önizleyin, kaydedin, yönetin',
    mobile_app_banner_title: 'Uygulamada kaydedin',
    reactivate_subscription_success:
      'Tekrar hoş geldiniz! Hesabınız yeniden etkinleştirildi. ',
    refresh_transfer_upload_lost:
      'Mevcut yüklemeyi iptal etmek istediğinizden emin misiniz?',
    update_payment_success: 'Ödeme bilgileriniz başarıyla güncellendi. Bingo!',
    update_user: 'Bilgileriniz güncellendi',
    current_team_notification:
      '%{currentTeam} ekibi olarak %{plan} kullanıyorsunuz',
    display_name_updated: 'Başlık güncellendi!',
    download_started:
      'İndirmeniz başlatıldı. İşlem tamamlandığında dosyalar bilgisayarınızda olacaktır (genellikle indirilenler klasöründe).',
    logged_out:
      'Görünüşe bakılırsa başka bir tarayıcıda hesabınızdan çıkış yapmışsınız. Lütfen tekrar oturum açın.',
    project_delete:
      '<strong>%{projectName}</strong> ve ona eklediğiniz dosyalar silinsin mi?',
    project_delete_success: '<strong>%{projectName}</strong> silindi',
    password_changed: 'Parola değiştirildi',
    password_removed: 'Parola kaldırıldı',
  },
  alert: {
    confirm_cancel_upload_image:
      'Mevcut yüklemeyi iptal etmek istediğinizden emin misiniz? ',
    cancel_recipient_locked: 'İptal et',
    cancel_refresh_transfer_upload_lost: 'Hayır',
    confirm_refresh_transfer_upload_lost: 'Evet',
    go_to_transfer: 'Aktarıma git',
    redirect_recipient_locked: 'Evet',
    stay: 'Kal',
    cancel_project_delete: 'İptal et',
    confirm_project_delete: 'Sil',
  },
  force_update:
    "Heyecan verici özellikler sizi bekliyor. WeTransfer'in en güncel sürümünü kullandığınızdan emin olmak için <a href=\"/\" onClick='javascript:window.location.reload();'>lütfen tarayıcınızı yenileyin</a>",
  user: {
    already_logged_in:
      'Zaten oturum açtınız. Parolanızı sıfırlamak istediğinizden emin misiniz?',
    roles: {
      admin: 'yönetici',
      owner: 'sahip',
      user: 'kullanıcı',
    },
    sign_out_and_reset: 'Oturumu kapat ve parolayı sıfırla',
  },
  click_here: 'Buraya tıklayın',
  cookiebox: {
    notice:
      '<bold>Şu anda oturum açmış durumdasınız</bold>, çerezlerinizi temizledikten sonra oturumunuz kapatılacaktır. Hesabınızdaki geçmiş transferler etkilenmeyecektir.',
  },
  notice: {
    general_issues:
      'İşler olması gerektiği gibi gitmiyor mu? Bunun can sıkıcı olduğunu biliyoruz, ancak biraz sabrederseniz her şeyi <a target="_blank" href=%{link}>en kısa zamanda</a> tekrar yoluna koyacağız',
    transfer_issues:
      'Transferinizde sorun mu yaşıyorsunuz? Bunun can sıkıcı olduğunu biliyoruz, ancak biraz sabrederseniz her şeyi <a target="_blank" href=%{link}>en kısa zamanda</a> tekrar yoluna koyacağız',
    verification:
      'Selam, <a href="/account">e-postanızı doğrulamanız</a> gerekiyor',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Hakkımızda | WeTransfer',
      advertise: 'Bize reklam verin | WeTransfer',
      apps: 'Mac, iOS ve Android için ücretsiz uygulamalar | WeTransfer Uygulamaları',
      forgot_password: 'Parolanızı sıfırlayın | WeTransfer Pro',
      help: 'Büyük dosyalar nasıl gönderilmeli? | WeTransfer Yardım',
      home: 'Büyük dosyaları ücretsiz olarak kolayca paylaşın | WeTransfer',
      plus: 'Daha büyük dosyalar göndermek için hesabınızı yükseltin | WeTransfer Pro',
      sign_in: 'Oturum açın | WeTransfer Pro',
      sign_up: 'Kaydol | WeTransfer Pro',
      upgrade: 'Hesap Yükseltme | WeTransfer Pro',
      pricing:
        'Fiyatlandırma | WeTransfer - Büyük Dosyalar Gönderin ve Fotoğrafları Çevrim İçi Paylaşın - 2 GB’a Kadar Ücretsiz',
    },
    descriptions: {
      help: 'WeTransfer için teknik desteğe mi ihtiyacınız var? Hızlı Yardım bölümümüzden büyük dosyaları nasıl göndereceğinizi öğrenebilir veya bizimle iletişime geçebilirsiniz.',
      social_help: 'Aradığınızı hâlâ bulamadınız mı?',
    },
  },
  splash: {
    footer: {
      or: 'veya',
      send_files: 'Sadece dosyalarımı göndermek istiyorum',
      no_thanks: 'Hayır, teşekkürler',
    },
    heading: {
      line_1_free: 'WeTransfer büyük dosyalar göndermenin en iyi yolu',
      line_2_free: "WeTransfer'den daha fazla yararlanın",
      free_account: 'Tekrar hoş geldiniz. Bunu resmîleştirmek ister misiniz?',
    },
    plan: {
      plus: {
        feature_10: 'E-postalarınızı kişiselleştirin',
        feature_11: "%{plus_storage_limit}'a kadar depolayın",
        feature_12: 'Transferlerin bitiş tarihine siz karar verin',
        feature_13: 'Transferlerinizi parola ile koruyun',
        feature_7: 'Profilinizi kişiselleştirin',
        feature_8: 'Kendi adres defterinizi oluşturun',
        feature_9: "WeTransfer URL'nizi kişiselleştirin",
      },
      free_account: {
        cta: 'Ücretsiz kayıt olun',
        feature_1: 'Depolama alanı yok',
        feature_2: "%{free_transfer_limit}'a kadar gönderin",
        feature_3: 'Transferleri yeniden gönderebilir veya silebilirsiniz',
        heading: 'WeTransfer Hesabı',
        price_label: 'Daima ücretsiz',
      },
      pro: {
        cta: "WeTransfer Pro'ı edinin",
        feature_1: '%{storage_limit_pro} depolama',
        feature_2: "%{transfer_limit_pro}'a kadar gönderip alma",
        feature_2_unlimited: 'Boyut sınırı olmadan dosya gönderin ve alın',
        feature_3: 'Transferleri yeniden gönderebilir veya silebilirsiniz',
        feature_4: 'Transferleri parola ile koruma',
        feature_5: "Kendinize ait Pro sayfası ve URL'si",
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: '%{recipient} ekibinize eklensin mi?',
      text_content:
        'Ekip üyeleri, ortak depolama alanı ve markalandırma ile birbirlerinin transferlerine erişebilirler. Bu işlem transferinizi iptal etmez.',
      cta: 'Haydi başlayalım',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Bağlantı kopyalandı',
      copy: 'Bağlantıyı kopyala',
      copy_again: 'Tekrar kopyala',
    },
    labels: {
      share: 'Bu transferi paylaş',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PRO İPUCU',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Portalleri deneyin',
        dismiss: 'Şimdi değil',
        text: '<strong>portaller</strong> ile müşterilerinizi ve işbirliği yaptığınız kişileri çalışmanızı görüntülemeye ve favorilerini seçmeye davet edebilirsiniz. Bu da daha az e-posta trafiği demek.',
        title: 'Çalışmanıza geri bildirim almanız mı gerekiyor... acilen mi?',
      },
      'second-viewing': {
        cta: 'Portalleri şimdi deneyin',
        dismiss: 'Bunu bir daha gösterme',
        text: 'Hızlı geri bildirim alın, yeni versiyonları paylaşın ve tüm bunları tek bir yerde yapın. <strong>portaller</strong> ile incelemeden revizyon ve son onaya kadar sorunsuz bir şekilde çalışmaya devam edebilirsiniz.',
        title: 'Çalışmayı gönderdiniz. Şimdi ne olacak?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: "Markalandırma'ya Git",
        text_2: 'Kendi video ve görsellerinizi eklemek ister misiniz?',
      },
      individual: {
        cta: 'Sayfayı oluştur',
        text: "İnsanlar dosyalarınızı her indirdiğinde harika bir izlenim bırakın; videolar veya görseller ekleyin ve kendi URL'nizi seçin.",
        title: 'Kendi WeTransfer sayfanızla sahne sizin',
      },
      invitee: {
        cta: 'Tamam',
        text_1:
          'Ekibinizin özel WeTransfer sayfası ile çalışmalarınızı her paylaştığınızda harika bir izlenim bırakacaksınız.',
        text_2:
          "Ekip duvar kağıtlarınızı <strong>Markalandırma</strong>'dan ne zaman isterseniz değiştirebilirsiniz",
        title: 'Gururla (ekip) çalışmanızı gösterin',
      },
      not_now: 'Şimdi değil',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Sayfayı oluştur',
                  premium: {
                    text: 'Ekibinizin WeTransfer sayfasından herkes size her boyutta transfer gönderebilir.',
                  },
                  text: 'Ekibinizin WeTransfer sayfasından herkes size %{transfer_limit_pro} boyutunda transferler gönderebilir.',
                },
                premium: {
                  transfer_link: {
                    text: '%{custom_link} sayfasından herkes size her boyutta transfer gönderebilir.',
                  },
                },
                transfer_link: {
                  text: "%{custom_link} üzerinden size herkes %{transfer_limit_pro}'a kadar transferler gönderebilir.",
                },
              },
              premium: {
                text: 'Ekibinizin WeTransfer sayfasından herkes size her boyutta transfer gönderebilir—onlara sadece bu bağlantıyı verin yeter.',
              },
              regular: {
                cta: 'Tamam',
                text: 'Ekibinizin WeTransfer sayfasından size herkes <strong>%{transfer_limit_pro}</strong> transferler gönderebilir. Onlara bu bağlantıyı vermeniz yeterli.',
                title: 'Ekibinize gönderilen her şey için tek bir yer',
              },
            },
            sent: {
              regular: {
                cta: 'Tamam',
                text: 'Ekibinizin gönderilen transferlerinin ortak genel bakışına hoş geldiniz. İndirmeleri izleyebilir, sona erme tarihlerini değiştirebilir ve hatta başka birinin transferlerini düzenleyebilir veya silebilirsiniz; ancak bunu yapmadan önce onlara haber vermeniz iyi olabilir!',
                title: 'Ekibinizin transferlerini yönetin',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus artık WeTransfer Pro ve 1 TB depolama alanı — yani 10 kat daha fazlası sizin. <a href="/transfers">Bir göz atın.</a>',
  },
  refer_friend: {
    title: 'Arkadaşlarınıza tavsiye edin',
    account: {
      description:
        'Arkadaşınız WeTransfer Pro veya Premium için kaydolduğunda hem size hem de kendisine 10 $ değerinde hediyemiz olacak. Sizi ön ödemeli kartlar, hayır işleri için bağışlar veya yüzlerce iş ortağında kullanılabilen hediye kartlarıyla ödüllendirebilmemiz için tavsiye bağlantınızı paylaşın.',
    },
    window: {
      link: 'Tavsiye bağlantısını al',
      send_another: 'Devam',
      text: 'Arkadaşınız WeTransfer Pro veya Premium için kaydolduğunda hem size hem de kendisine <strong>10 $1</strong> değerinde hediyemiz olacak.',
      title: 'Bir arkadaşınıza tavsiye edin',
      title_2: 'transfer gönderin.',
    },
    message: {
      success:
        'Burada iyi bir arkadaşınız var! WeTransfer Pro veya Premium için kaydolduğunuzda, ikiniz de 10 $ değerinde ön ödemeli kart, hayır işleri için bağış veya hediye kartı ile ödüllendirileceksiniz.',
      self: 'Ah hayır, tavsiye bağlantısında sorun var gibi görünüyor. WeTransfer Pro veya Premium için kaydolduğunuzda 10 $ değerinde ödül almak için lütfen arkadaşınızdan yeni bir bağlantı isteyin.',
      fallback:
        'Ah hayır, tavsiye bağlantısında sorun var gibi görünüyor. WeTransfer Pro veya Premium için kaydolduğunuzda 10 $ değerinde ödül almak için lütfen arkadaşınızdan yeni bir bağlantı isteyin.',
      expired: 'Üzgünüz, tavsiye bağlantınızın süresi dolmuş.',
      dismiss: 'Kapat',
    },
  },
  order_summary: {
    coupon: {
      link: 'Promosyon kodunu uygulayın',
      input_placeholder: 'Promosyon kodu',
      button_label: 'Uygulayın',
      error_message:
        'Üzgünüz, bu kod yalnızca %{billing_period} abonelikte indirim kazanmak için kullanılabilir.',
      generic_error_message: 'Üzgünüz, bu kod bu abonelik için uyumlu değil',
      input_error_message: 'Hmm, bu geçerli bir kod değil.',
      pill_label: {
        percentage: '-%%{percentage}',
      },
    },
    total: 'Toplam',
  },
  mobile_verify: {
    title: 'Artık hazırsınız',
    subtitle:
      'E-postanız doğrulandı. Artık transfer göndermek ve almak için uygulamayı kullanabilirsiniz.',
    cta: 'WeTransfer uygulamasını aç',
  },
  profile_and_security: {
    page_name: 'Profil ve güvenlik',
    profile_title: 'Profil',
    security_title: 'Güvenlik',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Mevcut <b>%{formattedintervaltotal}</b> /%{subscriptioninterval} planınız <b>%{autorenewalattempt}</b> tarihinde otomatik olarak yenilenecektir',
    current_team_workspace_information:
      'Mevcut <b>%{formattedTeamWorkspaceCost}</b> /%{subscriptioninterval} (%{membercount} x %{tieramount}) planınız <b>%{autorenewalattempt}</b> tarihinde otomatik olarak yenilenecektir',
    next_payment_date:
      'Bir sonraki ödeme tarihiniz <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b> /%{interval}',
    team_upgrade_calculation: '(%{membercount} üye x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Transferlerde boyut sınırı yoktur',
    premium_feature_two: 'Sınırsız depolama alanı',
    premium_feature_three: 'Sınırsız portal ve inceleme',
    premium_feature_four:
      '<a class="all-benefits-link" href="%{all_benefits_href}">Tüm avantajları</a> görün',
    premium_switch_cta_text: "Premium'a Geçin",
    pill_text: 'Mevcut plan',
    member_count: '%{membercount} üye',
    see_all_benefits: 'Tüm plan avantajlarını görün',
    pending_downgrade_current_subscription:
      'Çalışma alanı aboneliğiniz iptal edildi ve <b>%{cancellation_date}</b> tarihinde sona erecek.',
    pending_downgrade_reactivate_text:
      'Fikrinizi mi değiştirdiniz? Endişelenmeyin, her şey kolayca eski hâline döndürülebilir.',
    pending_downgrade_reactivate_cta: "Pro'ı yeniden etkinleştir",
    pending_downgrade_payment: 'Yaklaşan ödemeniz yok',
    update_payment_cta: 'Ödeme bilgilerini güncelle',
    cancel_plan:
      'Aboneliğinizi iptal ederseniz %{planName} çalışma alanınıza %{subscriptionRenewalDate} tarihine kadar erişebilirsiniz. ',
    cancel_expiry_text:
      'Bu tarihten sonra çalışma alanınız ücretsiz plana düşürülecek ve mevcut transferlerinizin süresi 28 gün sonra dolacaktır.',
    pending_payment_text:
      'Plan ve ödeme bilgilerinizi görmek için lütfen ödemenizi tamamlayın veya siparişinizi iptal edin.',
    learn_more: 'Planlar ve fiyatlandırma hakkında daha fazla bilgi edinin',
  },
  time: {
    days: {
      monday: 'Pazartesi',
      tuesday: 'Salı',
      wednesday: 'Çarşamba',
      thursday: 'Perşembe',
      friday: 'Cuma',
      saturday: 'Cumartesi',
      sunday: 'Pazar',
    },
    months: {
      january: 'Ocak',
      february: 'Şubat',
      march: 'Mart',
      april: 'Nisan',
      may: 'Mayıs',
      june: 'Haziran',
      july: 'Temmuz',
      august: 'Ağustos',
      september: 'Eylül',
      october: 'Ekim',
      november: 'Kasım',
      december: 'Aralık',
    },
    remaining: {
      minutes: {
        zero: 'Bir dakikadan az kaldı',
        one: 'Yaklaşık 1 dakika kaldı',
        other: 'Yaklaşık %{count} dakika kaldı',
      },
      hours: {
        one: 'Yaklaşık 1 saat kaldı',
        other: 'Yaklaşık %{count} saat kaldı',
      },
    },
  },
  download: {
    shortcut: 'Yüklemenin ilerleyişini görmek için %{command} tıkla',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: "%{size}'e kadar gönder",
    progress: {
      busy: 'Aktarılıyor...',
    },
    buttons: {
      add: 'Dosya ekle',
      transfer: 'Aktar',
      forward: 'İlet',
      add_ios6: 'Fotoğraf ve video ekle',
      add_ios7: 'Fotoğraf ekle',
    },
    forward: {
      done: 'İletim tamamlandı',
    },
    friend_email: {
      title: 'Arkadaşının e-postası',
      more: 'Daha fazla arkadaş ekle',
    },
    your_email: {
      title: 'E-posta adresin',
    },
    message: {
      title: 'Mesaj',
    },
    done: {
      title: 'Aktarım tamamlandı',
      link: 'İndirme bağlantısını kopyala:',
      copied: {
        title: 'Kopyalandı!',
        text: 'İndirme bağlantısı kopyalandı.',
      },
    },
    more_html: 'Daha fazla dosya ekle<span>(%{size})</span>',
    too_many_recipients:
      'Çok fazla e-posta adresi girmişsin. Unutma: Tek seferde %{count} kişiye kadar yer vardır.',
    completed: '%{size} / %{total} tamamlandı',
    addresses: {
      one: '%{count} adres',
      other: '%{count} adres',
      remove:
        '%{address} adresini önceki alıcılar listenden silmek istiyor musun?',
    },
    ads: {
      plus: {
        title: 'Pro ile WeTransfer’den daha fazla yararlan',
        text: "<ul><li>Büyük boyutlu karşıya yüklemeler</li><li>Özel arka plan ile kişiselleştirilmiş aktarımlar</li><li>Parola korumalı aktarımlar</li><li>Uzun süreli depolama</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Daha fazla bilgi al</a></p>",
      },
      plus2: {
        title: 'Kendi özel karşıdan yükleme sayfanla fark yarat',
        text: "<p>Alıcılarını etkilemek için kendine özel arka planı ve özel WeTransfer URL adresini (ismin.wetransfer.com) kullan.</p><p><a target='_blank' href='/pro?trk=inapp'>Daha fazla bilgi al</a></p>",
      },
      plus3: {
        title: 'Aktarımlarını daha akıllıca yönet',
        text: "<p>Bu aktarım 1 hafta sonra silinecektir, ancak WeTransfer Pro ile aktarımlarını yeniden yüklemeksizin süresiz olarak saklayabilir, gönderebilir ve anında silebilirsin.</p><p><a target='_blank' href='/pro?trk=inapp'>Daha fazla bilgi al</a></p>",
      },
      plus4: {
        title: 'Dosyaların için ekstra koruma edin',
        text: "<p>WeTransfer Pro ile önemli ve özel dosyalarını bir parolayla koruma altına alabilirsin. Bu sayede dosyaların asla yanlış ellere geçmez.</p><p><a target='_blank' href='/pro?trk=inapp'>Daha fazla bilgi al</a></p>",
      },
      facebook: {
        title: 'Facebook’ta WeTransfer topluluğuna katıl',
        text: "<p>En yeni haberleri al, ödüller kazan, yeni sanatçılar keşfet, röportajlar oku ve çok daha fazlası.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Daha fazla bilgi al</a>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email:
        'Üzgünüz, bir aktarım tekrar gönderilirken sadece e-posta desteklenir.',
      connect_twitter:
        'Twitter hesabın  WeTransfer ile henüz ilişkilendirilmemiş.',
      connect_facebook:
        'Facebook hesabın WeTransfer ile henüz ilişkilendirilmemiş.',
      transferproblems: {
        title: 'Aktarma sorunu',
        text: 'Bunu söylemek istemezdim ama aktarım sırasında bir sorun yaşandı.',
      },
      limitreached: {
        title: 'Depolama Limiti',
        text: '1 TB limitine ulaştın. Yeni dosyalar göndermek için eski aktarımlarından bazılarını sil.',
      },
      blocked: {
        title: 'Aktarma sorunu',
        text: 'Bilgisayar hayır diyor. Üzgünüm ama WeTransfer tarafından engellendin.',
      },
      upload_error: {
        title: 'Aktarma sorunu',
        text: 'Bunu söylemek istemezdim ama aktarım sırasında bir sorun yaşandı.',
      },
      unavailable: {
        title: 'Aktarma hatası',
        text: 'Kusura bakma, bu aktarım çoktan silinmiş, onu iletmemize imkan yok.',
      },
      startswithdot: {
        title: 'Hay aksi',
        text: 'Dosyalarından biri (ya da daha fazlası) nokta ile başlayan bir ada sahip. Bu işin sonu iyi görünmüyor. Lütfen dosyalarını yeniden adlandır ve eklemeyi tekrar dene.',
      },
      startswithspace: {
        title: 'Hay aksi',
        text: 'Dosyalarından biri (ya da daha fazlası) boşluk ile başlayan bir dosya adına sahip. Bu işin sonu iyi görünmüyor. Lütfen dosyalarını yeniden adlandır ve eklemeyi tekrar dene.',
      },
      containsreturn: {
        title: 'Hay aksi',
        text: 'Dosyalarından biri (ya da daha fazlası) geri dön imi içeren bir dosya adına sahip. Bunu nasıl başardığını anlayabilmiş değiliz, ama bunun işe yaramayacağını bilmelisin. Lütfen dosyalarını yeniden adlandır, sonra da eklemeyi tekrar dene.',
      },
      alreadyinlist: {
        title: 'Eyvah',
        text: 'Seçtiğin dosyalardan biri diğeriyle aynı ada sahip gibi görünüyor. Dosya adını biraz değiştirsen iyi olur!',
      },
      transfertoobig: {
        title: 'Amanın',
        text: "Hiç bu kadar üzülmemiştik, tek seferde  %{upload_limit}GB'den büyük bir dosya aktaramıyoruz.",
      },
      filetoobig: {
        title: 'Amanın',
        text: "Hiç bu kadar üzülmemiştik, tek seferde  %{upload_limit}GB'den büyük bir dosya aktaramıyoruz.",
      },
      zerobytes: {
        title: 'Hoppala',
        text: 'Dosyalarından biri (ya da daha fazlası) boş ya da okunamıyor.',
      },
      ioerror: {
        title: 'Başarısız',
        text: "Dosyalarından biri (ya da daha fazlası) okunamıyor ya da %{upload_limit}GB'den fazla. Kanatlanıp uçabileceğini sanmıyoruz.",
      },
      filenametoolong: {
        title: 'Eyvah',
        text: 'Dosyalarından biri (ya da daha fazlası) 250 karakterden uzun bir dosya adına sahip. Bundan uzun dosya adına sahip bir dosyayı kabul edemeyiz, lütfen yeniden adlandır.',
      },
      nofolders: {
        title: 'Amanın',
        text: 'Üzgünüz, klasörler henüz karşıya yüklenemiyor. Göndermeden önce dosyaları sıkıştırmayı dene.',
      },
      nofiles: {
        title: 'Hay aksi',
        text: 'Henüz bir dosya yüklemiş değilsin.',
      },
      norecipients: {
        title: 'Hayda!',
        text: 'Görünüşe bakılırsa herhangi bir alıcı e-posta adresi belirtmemişsin.',
      },
      toomanyrecipients: {
        title: 'Eyvah',
        text: 'Çok fazla alıcı yazmışsın.',
      },
      bigmessage: {
        title: 'Hey!',
        text: 'Mesajınız çok uzun. Lütfen kısaltın.',
      },
      nosender: {
        title: 'Ciddi misin?',
        text: 'Kendi e-posta adresini girmeyi unutmuşsun. Bunu nasıl yapabildin?',
      },
      senderemailinvalidformat: {
        title: 'Amanın',
        text: 'E-posta adresin yanlış gibi görünüyor. Nasıl yazdığına azıcık dikkat etsen!',
      },
      probablynotcopied: {
        title: 'Hay aksi',
        text: 'Bağlantıyı kopyalamamışsın gibi görünüyor.',
      },
      recipientemailinvalidformat: {
        title: 'Hay aksi',
        text: 'Arkadaşlarından birinin e-posta adresini yanlış girmişsin.',
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Eyvah',
        text: 'Dosyalarından biri (ya da daha fazlası) ters eğik çizgi içeren bir dosya adına sahip. Bunu kabul etmemiz mümkün değil. lütfen dosyalarını ters eğik çizgi içermeyecek şekilde adlandır.',
      },
      title: 'Hoppala',
      text: "iOS7 henüz sitemiz üzerinden video gönderilmesine izin vermiyor, ama <a href='%{wetransfer_ios_app_store_url}'>muhteşem WeTransfer uygulamamızla</a> bunu başarabilirsin!",
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tavsiye',
        text: "Aktarım başına 2 GB'ye kadar gönderebilirsin. Ve daha da iyisi var: İstediğin sıklıkta aktarabilirsin.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Önemli',
        text: "Pro hesabın transfer başına 20 GB'ye kadar gönderebilir fakat tarayıcın bunu engelliyor. <a href=/questions/33>Daha fazla bilgi için buraya tıkla.</a>",
      },
      recipients_tip: {
        title: 'Tavsiye',
        text: "%{email_limit}'ye kadar gönderilecek e-posta adresi girebilirsin. Yalnızca bir link yüklemek istiyorsan, aşağıdaki paylaş düğmesine tıkla.",
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tavsiye',
        text: 'Kendi e-posta adresini buraya yaz böylece dosyalar yüklendiğinde seninle irtibata geçebiliriz.',
      },
      expire_tip: {
        title: 'İpucu',
        text: 'Pro aktarımlarının süre bitiş tarihini şimdi değiştirebilirsin.',
      },
      message_tip: {
        title: 'Tavsiye',
        text: 'Arkadaşlarına dosyalarla beraber bir mesaj mı göndermek istiyorsun? Buradan yapabilirsin ama böyle bir zorunluluğun da yok.',
      },
      share_tip: {
        title: 'Tavsiye',
        text: 'Dosyaları paylaşma şeklini değiştir. E-postayla gönder veya bir karşıdan yükleme bağlantısı kullan.',
        text_plus:
          "Dosyaları paylaşma şeklini değiştir. E-postayla, Twitter'la, Facebook'la gönder veya bir yükleme linki kullan.",
      },
      download: {
        title: '',
        chrome:
          "Karşıdan yükleme işlemi burada daha farklı gerçekleşiyor. Biz artık bütün dosyaları tarayıcı vasıtası ile indiriyoruz, yani WeTransfer'de artık ilerleme çubuğu göremeyeceksin, dosyayı nerede saklamak istediğin de sorulmayabilir. Karşıdan yükleme ilerlemesini tarayıcı penceresinin alt kısmında görmen lazım, dosyan da varsayılan olarak İndirilenler klasöründe depolanacak. <a href='/questions/24' target='_blank'>Bu davranışı nasıl değiştirebileceğini burada öğrenebilirsin</a>.",
        firefox:
          "Karşıdan yükleme işlemi burada daha farklı gerçekleşiyor. Biz artık bütün dosyaları tarayıcı vasıtası ile indiriyoruz, yani WeTransfer'de artık ilerleme çubuğu göremeyeceksin, dosyayı nerede saklamak istediğin de sorulmayabilir. Karşıdan yükleme ilerlemesini tarayıcının Karşıdan yükleme penceresinde görmen lazım, dosyan da varsayılan olarak İndirilenler klasöründe depolanacak. <a href='/questions/24' target='_blank'>Daha fazlasını öğren</a>.",
        safari:
          "Karşıdan yükleme işlemi burada daha farklı gerçekleşiyor. Biz artık bütün dosyaları tarayıcı vasıtası ile indiriyoruz, yani WeTransfer'de artık ilerleme çubuğu göremeyeceksin, dosyayı nerede saklamak istediğin de sorulmayabilir. Karşıdan yükleme ilerlemesini tarayıcı penceresinin sağ üst kısmında görmen lazım, dosyan da varsayılan olarak İndirilenler klasöründe depolanacak. <a href='/questions/24' target='_blank'>Daha fazlasını öğren</a>.",
        old_explorer:
          "Karşıdan yükleme işlemi burada daha farklı gerçekleşiyor. Biz artık bütün dosyaları tarayıcı vasıtası ile indiriyoruz, yani WeTransfer'de artık ilerleme çubuğu göremeyeceksin, dosyayı nerede saklamak istediğin de sorulmayabilir. Ayrıca tarayıcı penceresinin üst kısmında bir güvenlik uyarısı görebilirsin. <a href='/questions/24' target='_blank'>Daha fazlasını öğren</a>.",
        explorer:
          "Karşıdan yükleme işlemi burada daha farklı gerçekleşiyor. Biz artık bütün dosyaları tarayıcı vasıtası ile indiriyoruz, yani WeTransfer'de artık ilerleme çubuğu göremeyeceksin,  dosyayı nerede saklamak istediğin de sorulmayabilir. Karşıdan yükleme ilerlemesini tarayıcı penceresinin alt kısmında görmen lazım (önce Kaydet'e tıklaman gerekebilir), dosyan da varsayılan olarak İndirilenler klasöründe depolanacak. <a href='/questions/24' target='_blank'>Daha fazlasını öğren</a>.",
        settings:
          'Tarayıcının ayarlarından varsayılan yükleme konumunu değiştirebilirsin.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding:
      'Bu aktarımın iletilmesi formun silinmesine neden olacak, emin misin?',
    is_busy: 'Üzgünüz, şu an bunu yapamayız.',
  },
  mobile_app: {
    remember_choice: 'Bu mesajı tekrar gösterme',
    uploader: {
      description:
        'Sitemiz şu anda mobil kullanım için uygun değildir. Ancak başarılı bir cep telefonu uygulamamız bulunmaktadır.',
      app_name: 'WeTransfer',
      download: 'Uygulamayı İndir',
      continue: "WeTransfer.com'a devam et",
    },
    downloader: {
      title: 'Dosyalarınız indirilmeye hazır',
      description_ios:
        'Dosyalarınızı sıkıştırılmış (zip) bir dosyada topladık. Dosyaları çıkarmak ve görüntülemek için bir uygulamaya ihtiyacınız var. <a href="https//itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a> uygulamasının bu işlem için oldukça uygun olduğunu düşünüyoruz.',
      description_android:
        'Dosyalarınızı sıkıştırılmış (zip) bir dosyada topladık. Dosyaları çıkarmak ve görüntülemek için bir uygulamaya ihtiyacınız var. <a href="https//play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a> uygulamasının bu işlem için oldukça uygun olduğunu düşünüyoruz.',
      continue: 'Anlaşıldı',
    },
  },
};
